import React, { useEffect, useMemo, useRef, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
// import "bootstrap/dist/css/bootstrap.min.css"
// import TableContainer from "../../components/Common/TableContainer"
import * as Yup from "yup"
import toastr from "toastr"
import "toastr/build/toastr.min.css";
import { useFormik } from "formik"
import {
  Tooltip, TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableBody,
  TextField, InputAdornment
} from "@material-ui/core"
//import components
// import Breadcrumbs from "../../components/Common/Breadcrumb"
import Switch from "react-switch"
import { makeStyles } from "@material-ui/core/styles"
import { Slider, Typography, Box, Grid, Paper } from "@mui/material";
import dayjs from "dayjs";
// import {
//   getUsers as onGetUsers,
//   addNewUser as onAddNewUser,
//   updateUser as onUpdateUser,
//   deleteUser as onDeleteUser,

// } from "../../store/actions"
import IconButton from '@material-ui/core/IconButton';
// import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import classnames from "classnames"
import Select from "react-select"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
// import { GetSUPPLIERdata ,GetCUSTOMERdata, GetProductinfodata, GetTaxinfodata} from "../../store/GetRecords/actions"
import { Divider, Button as MuiButton } from "@material-ui/core"
import { styled } from "@mui/system"

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardTitle,
  Button,
  Nav,
  CardBody,
  NavItem,
  Table,
  NavLink,
  Container,
  TabContent,
  TabPane,
} from "reactstrap"
import { Dialog, LinearProgress, Stack } from "@mui/material"
// import { useDispatch } from "react-redux"
// import DeleteModal from "../../components/Common/DeleteModal"
import axios from "../../axios"
import EditIcon from "@mui/icons-material/Edit"

import SweetAlert from "react-bootstrap-sweetalert"
import moment from "moment"


const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  dialogpaper: {
    width: "1200px",
  },
}))
const CustomButton = styled(Button)({
  boxShadow: 0,
  marginLeft: 5,
  backgroundColor: "#3468C0",
  color: "#yourCustomTextColor",
  "&:hover": {
    backgroundColor: "#2c3e50",
  },
})


function DatatableTables() {


  const [openLoader, setOpenLoader] = useState(false)

  const options1 = [
    { value: "0", text: "Select..." },
    { value: "1", text: "Level 1" },
    { value: "2", text: "Level 2" },
    { value: "3", text: "Level 3" },
  ]

  const options2 = [
    { value: "Dr", text: "Dr" },
    { value: "Cr", text: "Cr" },
  ]

  const options3 = [
    { value: "Dr", text: "Dr" },
    // {value: 'JV', text: 'JV'},
    { value: "Cr", text: "Cr" },
    // {value: 'Other', text: 'Other'}
  ]
  // const dispatch = useDispatch()




  // useLayoutEffect(() => {
  //   dispatch(GetSUPPLIERdata())



  //   dispatch(GetProductinfodata())

  //   dispatch(GetTaxinfodata())
  // }, [dispatch])


  const [allgroupcollections, setallgroupcollections] = useState([])

  const [allgroupcollections1, setallgroupcollections1] = useState([])

  const [GroupValue, setGroupValue] = useState({
    label: "Select...",
    value: "",
  })
  const [isFocused, setIsFocused] = useState(false);
  const [isFocused1, setIsFocused1] = useState(false);

  const [errunderurp, seterrunderurp] = useState(false)

  const [modal, setModal] = useState(false)

  const [isEdit, setIsEdit] = useState(false)
  const [tokent, settokent] = useState(
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ"
  )
  const [noRecords, setnoRecords] = useState(false)
  const [switch1, setswitch1] = useState(true)
  const [activeTab, setactiveTab] = useState("1")
  const [Deletiid, setDeletiid] = useState("")
  const [Buyerinfo, setBuyerinfo] = useState(false)
  const [Buyersuccess, setBuyersuccess] = useState(false)
  const [Buyererr, setBuyererr] = useState(false)
  const [allcustomercollections, setallcustomercollections] = useState([])
  const PhoneRegExps = /^[0-9 () +-]+$/
  const [allcountrycollections, setallcountrycollections] = useState([])
  const [allcitycollections, setallcitycollections] = useState([])
  const [allstatecollections, setallstatecollections] = useState([])
  const [duplicateerro, setduplicateerro] = useState(false)
  const [groupname, setgroupname] = useState("")
  const [subgroup, setsubgroup] = useState("")
  const [cityonedefaultvalue, setcityonedefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [onestatedefaultvalue, setonestatedefaultvalue] = useState({
    label: "Select...",
    value: "",
    id: "",
  })

  const [dateRange, setdateRange] = useState('')
  // setonestatedefaultvalue(
  //   !isEdit ? tempState : { label: "Select...", value: "", id: "" }
  // )
  const [onecountrydefaultvalue, setonecountrydefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [registerdate, setregisterdate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  )
  const [gsttrue, setgsttrue] = useState(false)

  const [useractive, setuseractive] = useState(false)

  const [CompanyCollection1, setCompanyCollection1] = useState([])
  const [companyNameHelp, setcompanyNameHelp] = useState({
    label: sessionStorage.getItem("companyName"),
    value: sessionStorage.getItem("Companyid"),
  })
  const [Active1, setActive1] = useState(true)

  //Addons
  const [POApprovalLevel, setPOApprovalLevel] = useState("")
  //Head office
  const [HeadOfficeHelp, setHeadOfficeHelp] = useState([])
  const [HeadOfficeNameHelp, setHeadOfficeNameHelp] = useState({
    label: "Select...",
    value: "",
  })
  // Ho
  const [HOFlg, setHOFlg] = useState(false)
  //walkin
  const [walkin, setwalkin] = useState(false)
  //wportal
  const [Wportal, setWportal] = useState(false)
  //Flag
  const [HoldOutstanding, setHoldOutstanding] = useState(false)
  const [zerosales, setzerosales] = useState(false)
  const [Promotional, setPromotional] = useState(false)
  const [IndentApporoval, setIndentApporoval] = useState(false)
  const [IncludeCity, setIncludeCity] = useState(false)
  const [IncludeState, setIncludeState] = useState(false)

  const [Openingbaltype, setOpeningbaltype] = useState("Dr")
  const [Creditflag, setCreditflag] = useState(false)

  //PopIp
  const [modal1, setModal1] = useState(false)

  //OpeningBalGrid
  const [openingbaldata, setopeningbaldata] = useState([])

  const [registerType, setregisterType] = useState("Registered")

  const [focusAfterClose, setFocusAfterClose] = useState(true)
  const [Gsterr, setGsterr] = useState(false)

  const [countryErr, setcountryErr] = useState(false)
  const [stateErr, setstateErr] = useState(false)
  const [cityErr, setcityErr] = useState(false)
  const [tempCountry, settempCountry] = useState()
  const [tempState, settempState] = useState()
  const [openBillNoErr, setopenBillNoErr] = useState(false)
  const [openBillDateErr, setopenBillDateErr] = useState(false)
  const [openBillAmt, setopenBillAmt] = useState(false)
  const [range, setRange] = useState([1, 31]);
  const [BuyerCollection, setBuyerCollection] = useState({
    Customer_Name: "",
    Contact_Person: "",
    Type: "",
    Address1: "",
    Address2: "",
    Area_Code: "",
    City: "",
    Zip_Code: "",
    // State: " ",
    // Country: "",
    Phone: " ",
    Fax: "",
    EmailId: " ",
    AccountsMailId: "",
    PurchaseMailId: "",
    PurchaseMail_Pwd: "",
    TIN_No: "",
    Exceed_Days: "",
    bank: "",
    IssueDate: "",
    ExpiryDate: "",
    CreditLimit: "",
    Created_By: "",
    Created_Date: "",
    Optype: "",
    Company_Id: "",
    Common: "",
    // ZeroSales: "",
    STNo: "",
    GSTNo: "               ",
    PANNo: "",
    Group_Id: "",
    OpeningBal: "0.00",
    OpeningDate: "",
    AccBranch: "",
    AccNo: "",
    IFSCCode: "",
    SwiftCode: "",
    MICRCode: "",
    GPAY_NO: "",
    Distance: "",
    CustomerHo_id: "",
    CustomerHo_Name: "",
    CustomerHO: "",
    // Promotional: "",
    OpenBalType: "",
    WalkIN: "",
    Prefix: "",
    TaxPer: "",
    TaxType: "",
    TaxCat: "",
    // CityId: "",
    Customer_Code: "",
    // RegisterType: "Registered",
    // StateId: "",
    // CountryId: "",
    // StateCode: "",
    Holdmail_Status: "",
    Cur_UserId: "",
    Cold_Call_Id: "",
    NatureOfTrans: "",
    TransPer: "",
    //indendreq:  "",
    //apprvllevel: "", "",
    IGSTApplicable: "",
    Webportal: "",
    Credit_Limit_Flg: "",
    Customer_Id: "",
  })

  function toggle12(tab) {
    if (activeTab !== tab) {
      setactiveTab(tab)
    }
  }


  const [citymodal, setcitymodal] = useState(false)
  const [citynamevalue, setcitynamevalue] = useState("")
  const [citycodevalue, setcitycodevalue] = useState("")
  const [cityidvalue, setcityidvalue] = useState("")
  const [CityNameerr, setCityNameerr] = useState(false)
  const [added, setadded] = useState(false)
  const [duplicateerr, setduplicateerr] = useState(false)
  const [Active, setActive] = useState(true)
  const [updated, setupdated] = useState(false)


  const pages = [
    5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 150, 200, 250, 300, 400, 500,
    600, 700, 800, 900, 1000,
  ];
  const [page, setpage] = useState(0);
  const [rowsperpage, setrowsperpage] = useState(pages[page]);
  const [dateRanges,setDateRanges]=useState([])
  const isFirstRender = useRef(true);

  const [deletedconfirm, setdeletedconfirm] = useState(false);

  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setrowsperpage(parseInt(event.target.value, 10));
    // setpage(0);
  };

  const changepage = () => {
    return allcustomercollections.slice(
      page * rowsperpage,
      (page + 1) * rowsperpage,
    );
  };


  //  tab key press color change  in type of
  const handleFocus = (e) => {
    e.target.style.borderColor = '#007bff';
  };

  const handleBlur = (e) => {
    e.target.style.borderColor = validation.touched.Type && validation.errors.Type ? 'red' : '#ced4da';
  };

  const handleHover = (e) => {
    e.target.style.borderColor = '#007bff';
  };

  const handleMouseLeave = (e) => {
    e.target.style.borderColor = validation.touched.Type && validation.errors.Type ? 'red' : '#ced4da';
  };
  // date Range
  const getMonthPreview = (startDay, endDay) => {
    const months = Array.from({ length: 12 }, (_, i) => dayjs().add(i, "month"));
    console.log("getMonthPreview running......")
    return months.map((month) => {
      const daysInMonth = month.daysInMonth();
      const from = Math.min(startDay, daysInMonth);
      const to = Math.min(endDay, daysInMonth);
      return {
        month: month.format("MMMM YYYY"),
        range: `${from} - ${to}`,
      };
    });
  };

const getFiscalMonthPreview = (startDay, endDay,manual) => {
  console.log("UseMemo getMonthPreview")
  const currentDate = dayjs();
  const currentMonth = currentDate.month(); // 0-indexed (0 = Jan, 3 = Apr)
  const currentYear=currentDate.year()
  const fiscalYearStartMonth = 3; // April (0 = Jan, so 3 = April)

  // If we're before April, fiscal year started last year
  const fiscalYearStart = currentMonth >= fiscalYearStartMonth
    ? dayjs().month(fiscalYearStartMonth).startOf("month")
    : dayjs().subtract(1, "year").month(fiscalYearStartMonth).startOf("month");

  const months = Array.from({ length: 12 }, (_, i) =>
    fiscalYearStart.add(i, "month")
  );

  const currentMonths=months.map(item=>item.format("MMMM"))
  const currenYears=months.map(item=>parseInt(item.format("YYYY")))

  const exsitingData=[];

  dateRanges.forEach(item=>{
    if(currentMonths.includes(item.Month) && currenYears.includes(parseInt(item.Year)))
      exsitingData.push(item)
  })

  let currExisting=null;
  let pointer=0;
  return months.map((item) => {
    const month=item.format("MMMM")
    const year=parseInt(item.format("YYYY"))
    let daysInMonth = item.daysInMonth();
    let from = Math.min(startDay, daysInMonth)
    let to = Math.min(endDay, daysInMonth);
    if(currentMonth>item.month() && currentYear>=year ){
      if(exsitingData.length!==0 ){
        if(pointer<exsitingData.length && parseInt(exsitingData[pointer].Year)===year && exsitingData[pointer].Month===month){
          currExisting=exsitingData[pointer++];
        }

        if(currExisting)
          return {
             month: `${month} ${year}`,
             range: `${currExisting.DateRange}`,
          }
      }
      return {
         month: `${month} ${year}`,
         range: `1 - ${daysInMonth}`,
      }
    }
    if(!manual && pointer<exsitingData.length && parseInt(exsitingData[pointer].Year)===year && exsitingData[pointer].Month===month){
       currExisting=exsitingData[pointer++]
    }
    if(!manual && currExisting){
          return {
             month: `${month} ${year}`,
             range: `${currExisting.DateRange}`,
          }
    }
   return {
      month: `${month} ${year}`,
      range: `${from} - ${to}`,
    };
  });
};

const fiscalMonthPreview = useMemo(() => {
  const useFiscal = !isFirstRender.current;
  const result = getFiscalMonthPreview(range[0], range[1], useFiscal);
  return result;
}, [range,dateRanges]);

const previews = getMonthPreview(range[0], range[1]);

  const handleSliderChange = (event, newValue) => {
    isFirstRender.current = false; 
    setRange(newValue);
    setdateRange(newValue[0] + '-' + newValue[1])
  };

  const GetDateRange=async (CustomerId)=>{
    try{
      isFirstRender.current=true;
      const res=await axios.instance
          .post('/GetOneDateRange', {CustomerId},{
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            })
      setDateRanges(res.data)
    }catch(err){
      console.log(err.message)
      setDateRanges([])
    }
  }


  const InsertCityMasterData = async () => {
    if (cityEdit == false) {
      if (citynamevalue.length !== 0) {
        const get1 = await axios.instance
          .post(
            `/InsertCityMaster`,
            {
              City_Id: 0,
              City_Code: 0,
              City_Name: citynamevalue,
              Active: Active === true ? "Y" : "N",
              IsSecondary: "N",
              Optype: "New",
            },
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          .then(res => {
            if (res.data.length === 1) {
              setcitycodevalue("")
              setcitynamevalue("")
              setcityidvalue("")
              setcityonedefaultvalue({ label: "Select...", value: "" })
              citymodalvalue()
              setadded(true)
              setcityEdit(false)
              Getallcity()
            } else {
              setduplicateerr(true)
            }
          })
      } else {
        if (citynamevalue.length === 0) {
          setCityNameerr(true)
        }
        setTimeout(() => {
          setCityNameerr(false)
        }, 4000)
      }
    } else {
      if (citynamevalue.length !== 0) {
        const get1 = await axios.instance
          .post(
            `/InsertCityMaster`,
            {
              City_Id: cityidvalue,
              City_Code: 0,
              City_Name: citynamevalue,
              Active: Active === true ? "Y" : "N",
              IsSecondary: "N",
              Optype: "Edit",
            },
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          .then(res => {
            setActive1(true)
            // console.log(res.data,'value')
            if (res.data.length === 1) {
              setcitycodevalue("")
              setcitynamevalue("")
              setcityidvalue("")
              setcityonedefaultvalue({ label: "Select...", value: "" })
              citymodalvalue()
              Getallcity()
              setcityEdit(false)
              setupdated(true)
            } else {
              setduplicateerr(true)
            }
          })
      } else {
        if (citynamevalue.length === 0) {
          setCityNameerr(true)
        }
        setTimeout(() => {
          setCityNameerr(false)
        }, 4000)
      }
    }
  }

  const citymodalvalue = () => {
    if (citymodal) {
      setcitymodal(false)

    } else {
      setcitymodal(true)

    }
  }

  const getonecityvalue = async id => {
    console.log(id, "v")
    setcityEdit(true)
    const get = await axios.instance
      .get(`/Getonecity/${id}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        console.log(res.data, "city")
        const data = res.data
        for (const data of res.data) {
          setcitynamevalue(data.City_Name)
          setcitycodevalue(data.City_Code)
          setcityidvalue(data.City_Id)
          // setcityonedefaultvalue({ label: data.City_Name, value: data.City_Id})
        }
      })
  }

  // statemaster
  const [stateEdit, setstateEdit] = useState(false)
  const [cityEdit, setcityEdit] = useState(false)
  const [statenamevalue, setstatenamevalue] = useState("")
  const [statecodevalue, setstatecodevalue] = useState("")
  const [stateidvalue, setstateidvalue] = useState("")
  const [statetoggle, setstatetoggle] = useState(false)
  const [statecodeerror, setstatecodeerror] = useState(false)
  const [statenameerror, setstatenameerror] = useState(false)
  const [stateedit, setstateedit] = useState(false)
  const [stateaddmessage, setstateaddmessage] = useState(false)
  const [sateupdate, setsateupdate] = useState(false)
  const [statealreadyExists, setstatealreadyExists] = useState(false)

  const togglestatevalue = () => {
    if (statetoggle) {
      setstatetoggle(false)
    } else {
      setstatetoggle(true)
    }
  }

  const insertstatemaster = async () => {
    if (stateEdit == false) {
      if (statenamevalue.length !== 0 && statecodevalue !== 0) {
        const get1 = await axios.instance
          .post(
            `/Insertstatemst`,
            {
              StateName: statenamevalue,
              StateCode: statecodevalue,
            },
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          .then(res => {
            if (res.data === "Already Exists") {
              setstatealreadyExists(true)
            } else {
              Getallstate()
              setstatenamevalue("")
              setstatecodevalue("")
              setstateidvalue("")
              setstateEdit(false)
              setonestatedefaultvalue({ label: "Select...", value: "", id: "" })
              setstateaddmessage(true)
              togglestatevalue()
            }
          })
      } else {
        if (statenamevalue.length === 0) {
          setstatenameerror(true)
        }
        if (statecodevalue.length === 0) {
          setstatecodeerror(true)
        }
        setTimeout(() => {
          setstatecodeerror(false)
          setstatenameerror(false)
        }, 2000)
      }
    }
  }

  const updatestatemaster = async () => {
    if (statenamevalue.length !== 0 && statecodevalue !== 0) {
      const get1 = await axios.instance
        .put(
          `/Updatestatemst/${stateidvalue}`,
          {
            StateName: statenamevalue,
            StateCode: statecodevalue,
          },
          {
            headers: {
              Authorization: tokent,
              "Content-Type": "application/json",
            },
          }
        )
        .then(res => {
          if (res.data === "Already Exists") {
            setstatealreadyExists(true)
          } else {
            Getallstate()
            setstatenamevalue("")
            setstatecodevalue("")
            setstateidvalue("")
            setstateEdit(false)
            setonestatedefaultvalue({ label: "Select...", value: "", id: "" })
            // setstateaddmessage(true)
            setsateupdate(true)
            togglestatevalue()
          }
        })
    } else {
      if (statenamevalue.length === 0) {
        setstatenameerror(true)
      }
      if (statecodevalue.length === 0) {
        setstatecodeerror(true)
      }
      setTimeout(() => {
        setstatecodeerror(false)
        setstatenameerror(false)
      }, 2000)
    }
  }









  const toggle1 = () => setModal1(!modal1)

  const tab1validtiontab1 = tab => {
    console.log(onestatedefaultvalue, 'onestatedefaultvalue')
    if (onecountrydefaultvalue.value == 2) {
      if (
        GroupValue.value === "" ||
        cityonedefaultvalue.value === "" ||
        validation.values.Zip_Code.length === 0 ||
        validation.values.Customer_Name.length === 0 ||
        validation.values.Address1.length === 0 ||
        validation.values.Phone.length === 0 ||
        validation.values.EmailId.length === 0 ||
        validation.values.Contact_Person.length === 0 ||
        onestatedefaultvalue.value === "" ||
        onecountrydefaultvalue.value === ""

      ) {
        // if(onecountrydefaultvalue.value== 2){
        console.log('true')
        if (cityonedefaultvalue.value.length == 0) {
          setcityErr(true)
        }
        // }


        if (onestatedefaultvalue.value === "") {
          setstateErr(true)
        }
        if (onecountrydefaultvalue.value === "") {
          setcountryErr(true)
        }
        if (GroupValue.value === '') {
          seterrunderurp(true)
        }
        validation.setFieldTouched("Zip_Code")
        validation.setFieldTouched("Customer_Name")
        validation.setFieldTouched("Address1")
        validation.setFieldTouched("Phone")
        validation.setFieldTouched("EmailId")
        validation.setFieldTouched("Contact_Person")

        setTimeout(() => {
          setcityErr(false)
          setstateErr(false)
          setcountryErr(false)
          seterrunderurp(false)
        }, 3000)
      }
      else {
        if (activeTab !== tab) {
          setactiveTab(tab)
        }
      }
    } else {
      if (
        GroupValue.value === "" ||
        validation.values.Zip_Code.length === 0 ||
        validation.values.Customer_Name.length === 0 ||
        validation.values.Address1.length === 0 ||
        validation.values.Phone.length === 0 ||
        validation.values.EmailId.length === 0 ||
        validation.values.Contact_Person.length === 0 ||
        onestatedefaultvalue.value === "" ||
        onecountrydefaultvalue.value === ""

      ) {
        // if(onecountrydefaultvalue.value== 2){
        // console.log('true')
        // if (cityonedefaultvalue.value.length == 0) {
        //   setcityErr(true)
        // }
        // }


        // if (onestatedefaultvalue.value === "") {
        //   setstateErr(true)
        // }
        if (onecountrydefaultvalue.value === "") {
          setcountryErr(true)
        }
        if (GroupValue.value === '') {
          seterrunderurp(true)
        }
        // validation.setFieldTouched("Zip_Code")
        // validation.setFieldTouched("Customer_Name")
        // validation.setFieldTouched("Address1")
        // validation.setFieldTouched("Phone")
        // validation.setFieldTouched("EmailId")
        // validation.setFieldTouched("Contact_Person")

        setTimeout(() => {
          setcityErr(false)
          setstateErr(false)
          setcountryErr(false)
          seterrunderurp(false)
        }, 3000)
      }
      else {
        if (activeTab !== tab) {
          setactiveTab(tab)
        }
      }

    }

  }

  const tab1validtiontab2 = tab => {
    // if(validation.values.RegisterType != 'Unregistered' && validation.values.RegisterType !='Composition'){

    //   if (validation.values.GSTNo.length > 14  ) {

    //   if (activeTab !== tab  ) {
    //     setactiveTab(tab)
    //   }

    //   }else {

    //   validation.setFieldTouched('GSTNo')

    //   }
    // }
    // else{
    //   validation.values.GSTNo ='               '

    //   if (activeTab !== tab  ) {
    //     setactiveTab(tab)
    //   }
    // }

    if (registerType != "Unregistered") {
      if (validation.values.GSTNo.length > 14) {
        if (activeTab !== tab) {
          setactiveTab(tab)
        }
      } else {
        validation.setFieldTouched("GSTNo")
      }
    } else {
      validation.values.GSTNo = "               "
      if (activeTab !== tab) {
        setactiveTab(tab)
      }
    }
  }

  const tab1validtiontab3 = tab => {
    if (activeTab !== tab) {
      setactiveTab(tab)
    }
  }

  const phoneRegExp = /^[0-9 () +-]+$/
  const Country = /^[a-zA-Z ]+$/
  // validation



  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: BuyerCollection,
    validationSchema: Yup.object({
      Customer_Name: Yup.string()
        .required("Please Enter Customer Name")
        .max(60, "Customer Name Must Be Atmost 60 Characters"),

      Contact_Person: Yup.string()
        .max(50, "Contact Person Must Be Atmost 50 Characters")
        .required("Please Enter Contact Person"),

      Address1: Yup.string().required("Please Enter Address1"),

      Zip_Code: Yup.string().required("Please Enter Pin Code"),

      Phone: Yup.string()
        .matches(PhoneRegExps, "Please Enter a valid Phone No")
        .min(5, "Phone No Must Be Atleast 5 Digits")
        .max(15, "Phone No Must Be Atmost 15 Digits")
        .required("Please Enter Phone No"),

      EmailId: Yup.string()
        .email("EmailId Must Be Valid")
        .required("Please Enter EmailId"),

      GSTNo: Yup.string().when("registerType", (registerType, schema) => {
        return registerType !== "Unregistered"
          ? schema
            .min(15, "GST No Must Be Atleast 15 Digits")
            .max(15, "GST No Must Be Atmost 15 Digits")
            .required("Please Enter GST No")
          : schema.notRequired();
      }),

      Fax: Yup.string().max(10, "Fax No Must Be Atmost 10 Digits"),

      Area_Code: Yup.string(),

      bank: Yup.string().max(50, "Bank Name Must Be Atmost 50 Characters"),

      IFSCCode: Yup.string().max(30, "IFSC Code Must Be Atmost 30 Characters"),

      AccNo: Yup.string().max(30, "Account No Must Be Atmost 30 Characters"),

      AccBranch: Yup.string().max(30, "Branch Name Must Be Atmost 30 Characters"),

      PANNo: Yup.string().max(30, "PAN No Must Be Atmost 30 Characters"),

    }),
    // OLD FORMIK
    // validationSchema: Yup.object({
    //   Customer_Name: Yup.string()
    //     .required("Please Enter Customer Name")
    //     .max(60, "Customer Name Must Be Atmost 60 Characters"),
    //   Contact_Person: Yup.string()
    //     .max(50, "Contact Person Must Be Atmost 50 Characters")
    //     .required("Please Enter Contact Person"),
    //   Address1: Yup.string().required("Please Enter  Address1"),

    //   Zip_Code: Yup.string()
    //     .required("Please Enter Pin Code "),
    //     // .min(6, "Pin Code Must Be atleast 6 Digits"),
    //   Phone: Yup.string()
    //     .min(5, "Phone No Must Be Atleast 5 Digits")
    //     .max(15, "Phone No Must Be Atmost 15 Digits")
    //     .matches(PhoneRegExps, "Please Enter valid Phone No")
    //     .required("Please Enter Phone No"),
    //   EmailId: Yup.string()
    //     .email("EmailId  Must Be Valid")
    //     .required("Please Enter EmailId"),
    //   // GSTNo: Yup.string()
    //   //   .min(15, "GST No Must Be Atleast 15 Digits")
    //   //   .max(15, "GST No Must Be Atmost 15 Digits")
    //   //   .required("Please Enter GST No"),
    //   GSTNo: Yup.string().when("registerType", {
    //     is: registerType => registerType !== "Unregistered",
    //     then: Yup.string()
    //       .min(15, "GST No Must Be Atleast 15 Digits")
    //       .max(15, "GST No Must Be Atmost 15 Digits")
    //       .required("Please Enter GST No"),
    //     otherwise: Yup.string().notRequired(), // Skip validation when registerType is 'Unregistered'
    //   }),
    //   Fax: Yup.string().max(10, " Fax No Must Be Atmost 10 Digits "),
    //   Area_Code: Yup.string(),
    //     // .min(10, "Mobile No Must Be Atleast 10 Digits ")
    //     // .max(15, "Mobile No Must be Atmost 15 Digits"),
    //   bank: Yup.string().max(50, "Bank Name Must Be atmost 50 Characters"),
    //   IFSCCode: Yup.string().max(30, "IFSCCode Must Be Atmost 30 Characters"),
    //   AccNo: Yup.string().max(30, "Account No Must Be Atmost 30 Characters"),
    //   AccBranch: Yup.string().max(
    //     30,
    //     "Branch Name Must Be Atmost 30 characters"
    //   ),
    //   PANNo: Yup.string().max(30, "PANNo Must Be Atmost 30 Characters"),
    // }),

    onSubmit: async values => {
      setOpenLoader(true)
      console.log(registerType, "type")
      if (isEdit) {
        const CreateBuyer = await axios.instance
          .post(
            `/insertcustomerdetails`,
            {
              Customer_Name: values.Customer_Name,
              Contact_Person: values.Contact_Person,
              Type: values.Type,
              Address1: values.Address1,
              Address2: values.Address2,
              Area_Code: values.Area_Code,
              City: cityonedefaultvalue.label,
              Zip_Code: values.Zip_Code,
              State: onestatedefaultvalue.label,
              Country: onecountrydefaultvalue.label,
              Phone: values.Phone,
              Fax: values.Fax,
              EmailId: values.EmailId,
              AccountsMailId: values.AccountsMailId,
              PurchaseMailId: values.PurchaseMailId,
              PurchaseMail_Pwd: values.PurchaseMail_Pwd,
              TIN_No: values.TIN_No,
              Exceed_Days: values.Exceed_Days,
              Active: switch1 ? "Y" : "N",
              bank: values.bank,
              BankType: 'Current',
              IssueDate: registerdate,
              ExpiryDate: moment(new Date()).format("YYYY-MM-DD"),
              CreditLimit: values.CreditLimit,
              Modify_By: sessionStorage.getItem("Userid"),
              Modify_Date: moment(new Date()).format("YYYY-MM-DD"),
              Optype: "Edit",
              Company_Id: sessionStorage.getItem("Companyid"),
              Common: "0",
              ZeroSales: zerosales === true ? 1 : 0,
              STNo: values.STNo,
              GSTNo:
                registerType === "Unregistered"
                  ? "               "
                  : values.GSTNo,
              PANNo: values.PANNo,
              Group_Id: GroupValue.value,
              OpeningBal: values.OpeningBal,
              OpeningDate: moment(new Date()).format("YYYY-MM-DD"),
              AccBranch: values.AccBranch,
              AccNo: values.AccNo,
              IFSCCode: values.IFSCCode,
              SwiftCode: "",
              MICRCode: "",
              GPAY_NO: values.GPAY_NO,
              Distance: "0.00",
              CustomerHo_id: HeadOfficeNameHelp.value,
              CustomerHo_Name: HeadOfficeNameHelp.label,
              CustomerHO: HOFlg === true ? "Y" : "N",
              Promotional: Promotional === true ? 1 : 0,
              OpenBalType: Openingbaltype,
              WalkIN: walkin === true ? "Y" : "N",
              Prefix: "",
              TaxPer: "0.00",
              TaxType: "Input",
              TaxCat: "CGST",
              CityId: cityonedefaultvalue.value,
              Customer_Code: values.Customer_Code,
              RegisterType: registerType,
              StateId: onestatedefaultvalue.id,
              CountryId: onecountrydefaultvalue.value,
              StateCode: onestatedefaultvalue.value,
              Holdmail_Status: HoldOutstanding === true ? "Y" : "N",
              Cur_UserId: "1",
              HSNCode: 0,
              GST_Applicability: 'N',

              Tax: 0,
              TypeofSupply: '',
              ValidDate: new Date(),
              Cold_Call_Id: "0",
              NatureOfTrans: "",
              TransPer: "0.00",
              indendreq: IndentApporoval === true ? "Y" : "N",
              apprvllevel: POApprovalLevel,
              IGSTApplicable: useractive === true ? "Y" : "N",
              Webportal: Wportal === true ? "Y" : "N",
              Credit_Limit_Flg: Creditflag === true ? "Y" : "N",
              Calculation_Of_GST: "N",
              Concern_Of_GST: '',
              Customer_Id: validation.values.Customer_Id,
              DateRange: dateRange ? dateRange : `${range[0]}-${range[1]}`,
            },
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          .then(res => {
            if (res.data.length === 1) {
              DateRangeLogData()
              console.log(res.data)
              setBuyerinfo(true)
              setModal(false)
              resetform()
              if (openingbaldata.length !== 0) {
                InserrtOpeningBaledit(validation.values.Customer_Id).then(
                  () => {
                    setopeningbaldata([])
                  }
                )
              }
              getallcustomers1(Active1)
              validation.resetForm()
              setOpenLoader(false)
            } else {
              setduplicateerro(true)
              setOpenLoader(false)
            }
          })
      } else {
        const CreateBuyer = await axios.instance
          .post(
            `/insertcustomerdetails`,
            {
              Customer_Name: values.Customer_Name,
              GST_Applicability: 'N',
              HSNCode: 0,
              BankType: 'Current',
              Tax: 0,
              TypeofSupply: '',
              ValidDate: new Date(),
              Contact_Person: values.Contact_Person,
              Type: values.Type,
              Address1: values.Address1,
              Address2: values.Address2,
              Area_Code: values.Area_Code,
              City: cityonedefaultvalue.label,
              Zip_Code: values.Zip_Code,
              State: onestatedefaultvalue.label,
              Country: onecountrydefaultvalue.label,
              Phone: values.Phone,
              Fax: values.Fax,
              EmailId: values.EmailId,
              AccountsMailId: values.AccountsMailId,
              PurchaseMailId: values.PurchaseMailId,
              PurchaseMail_Pwd: values.PurchaseMail_Pwd,
              TIN_No: values.TIN_No,
              Exceed_Days: values.Exceed_Days,
              Active: switch1 ? "Y" : "N",
              bank: values.bank,
              IssueDate: registerdate,
              ExpiryDate: moment(new Date()).format("YYYY-MM-DD"),
              CreditLimit: values.CreditLimit,
              Created_By: sessionStorage.getItem("Userid"),
              Created_Date: moment(new Date()).format("YYYY-MM-DD"),
              Optype: "New",
              Company_Id: sessionStorage.getItem("Companyid"),
              Common: "0",

              ZeroSales: zerosales === true ? 1 : 0,
              STNo: values.STNo,
              GSTNo:
                registerType === "Unregistered"
                  ? "               "
                  : values.GSTNo,
              PANNo: values.PANNo,
              Group_Id: GroupValue.value,
              OpeningBal: values.OpeningBal,
              OpeningDate: moment(new Date()).format("YYYY-MM-DD"),
              AccBranch: values.AccBranch,
              AccNo: values.AccNo,
              IFSCCode: values.IFSCCode,
              SwiftCode: "",
              MICRCode: "",
              GPAY_NO: values.GPAY_NO,
              Distance: "0.00",
              CustomerHo_id: HeadOfficeNameHelp.value,
              CustomerHo_Name: HeadOfficeNameHelp.label,
              CustomerHO: HOFlg === true ? "Y" : "N",
              Promotional: Promotional === true ? 1 : 0,
              OpenBalType: Openingbaltype,
              WalkIN: walkin === true ? "Y" : "N",
              Prefix: "",
              TaxPer: "0.00",
              TaxType: "Input",
              TaxCat: "CGST",
              CityId: cityonedefaultvalue.value,
              Customer_Code: values.Customer_Code,
              RegisterType: registerType,
              StateId: onestatedefaultvalue.id,
              CountryId: onecountrydefaultvalue.value,
              StateCode: onestatedefaultvalue.value,
              Holdmail_Status: HoldOutstanding === true ? "Y" : "N",
              Cur_UserId: "1",
              Cold_Call_Id: "0",
              NatureOfTrans: "",
              TransPer: "0.00",
              indendreq: IndentApporoval === true ? "Y" : "N",
              apprvllevel: POApprovalLevel,
              IGSTApplicable: useractive === true ? "Y" : "N",
              Webportal: Wportal === true ? "Y" : "N",
              Credit_Limit_Flg: Creditflag === true ? "Y" : "N",
              Calculation_Of_GST: "N",
              Concern_Of_GST: '',
              Customer_Id: "",
              DateRange: dateRange ? dateRange : `${range[0]}-${range[1]}`,
            },
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          .then(res => {
            if (res.data.length === 1) {
              DateRangeLogData()
              resetform()
              setModal(false)
              getallcustomers1(Active1)
              if (openingbaldata.length !== 0) {
                let varrr = []
                for (const data of res.data) {
                  varrr.push(data.Customer_Id)
                }
                InserrtOpeningBal(varrr).then(() => {
                  setopeningbaldata([])
                })
              }
              // toggle()
              setBuyersuccess(true)
              validation.resetForm()
              setOpenLoader(false)
            } else {
              setduplicateerro(true)

              setOpenLoader(false)
            }
          })
      }
    },
  })


  // InsertLogDate
  const DateRangeLogData = async () => {
    console.log(dateRange, 'dateRange');
    try {
      const data = await axios.instance.post(
        '/InsertDateRangeLog',
        {
          CustomerId: validation.values.Customer_Id,
          DateRange: dateRange,
          CreatedBy: sessionStorage.getItem("Userid"),
          ModifiedBy: 0
        },
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('Log Inserted:', data);
      return data;
    } catch (error) {
      console.error('Error inserting log:', error);
      throw error;
    }
  };


  // const toggleViewModal = () => setModal1(!modal1);

  const toggle = () => {
    setModal(false)
    resetform()
  }

  const handleUserClick = arg => {
    console.log(arg, 'arg')
    const Buyer = arg
    GetOneOpeningBal(Buyer.customer_id)
    GetDateRange(Buyer.customer_id)
    if (Buyer.active === "Y") {
      setswitch1(true)
    } else {
      setswitch1(false)
    }
    setgsttrue(Buyer.registertype === "Unregistered")
    setBuyerCollection({
      Customer_Name: Buyer.customer_name,
      Contact_Person: Buyer.contact_person,
      Type: Buyer.type,
      Address1: Buyer.address1,
      Address2: Buyer.address2,
      Area_Code: Buyer.area_code,
      City: Buyer.city,
      Zip_Code: Buyer.zip_code,
      Phone: Buyer.phone,
      Fax: Buyer.fax,
      EmailId: Buyer.emailid,
      AccountsMailId: Buyer.accountsmailid,
      PurchaseMailId: Buyer.purchasemailid,
      PurchaseMail_Pwd: Buyer.purchasemail_pwd,
      TIN_No: Buyer.tin_no,
      Exceed_Days: Buyer.exceed_days,
      // Active:Buyer.,
      bank: Buyer.bank,
      IssueDate: Buyer.issuedate,
      ExpiryDate: Buyer.expirydate,
      CreditLimit: Buyer.creditlimit,
      Common: Buyer.common,
      // ZeroSales: Buyer.zerosales,
      STNo: Buyer.stno,
      GSTNo: Buyer.gstno,
      PANNo: Buyer.panno,
      Group_Id: Buyer.group_id,
      OpeningBal: Buyer.openingbal,
      OpeningDate: Buyer.openingdate,
      AccBranch: Buyer.accbranch,
      AccNo: Buyer.accno,
      IFSCCode: Buyer.ifsccode,
      SwiftCode: Buyer.swiftcode,
      MICRCode: Buyer.micrcode,
      GPAY_NO: Buyer.gpay_no,
      Distance: Buyer.distance,
      // CustomerHo_id: Buyer.customerho_id,
      // CustomerHo_Name: Buyer.customerho_name,
      // CustomerHO: Buyer.customerho === "N" ? false : true,
      // Promotional: Buyer.promotional,
      // OpenBalType: Buyer.openbaltype,
      // WalkIN: Buyer.walkin === "N" ? false : true,
      // Prefix:Buyer.,
      TaxPer: Buyer.taxper,
      TaxType: Buyer.taxtype,
      TaxCat: Buyer.taxcat,
      CityId: Buyer.CityId,
      Customer_Code: Buyer.customer_code,
      // RegisterType: Buyer.registertype,
      // StateId: Buyer.stateid,
      // CountryId: Buyer.countryid,
      // StateCode: Buyer.statecode,
      // Holdmail_Status: Buyer.holdmail_status === "Y" ? true : false,
      Cur_UserId: "",
      Cold_Call_Id: Buyer.cold_call_id,
      NatureOfTrans: "",
      TransPer: Buyer.taxper,
      // indendreq: Buyer.indendreq === "N" ? false : true,
      // //apprvllevel: "", Buyer.apprvllevel === "0" ? false : true,
      // IGSTApplicable: Buyer.igstapplicable === "N" ? false : true,
      // Webportal: Buyer.webportal === "Y" ? true : false,
      Credit_Limit_Flg: Buyer.credit_limit_flg === "N" ? false : true,
      Customer_Id: Buyer.customer_id,
    })
    const range = Buyer.DateRange ? Buyer.DateRange.split('-').map(Number) : [1, 31];
    // setRange(
    //   Buyer.DateRange ? Buyer.DateRange.split('-').map(Number) : [1, 31]
    // );
    // setdateRange(Buyer.DateRange[0] + '-' + Buyer.DateRange[1])
    setRange(range);
    setdateRange(`${range[0]}-${range[1]}`);



    setuseractive(Buyer.igstapplicable === "Y")
    setWportal(Buyer.webportal === "Y")
    setwalkin(Buyer.walkin === "Y")
    setHOFlg(Buyer.customerho === "Y")
    setzerosales(Buyer.zerosales)
    setPromotional(Buyer.promotional)
    setIndentApporoval(Buyer.indendreq === "Y")
    // setIncludeCity(Buyer.zerosales)
    // setIncludeState(Buyer.zerosales)
    setHoldOutstanding(Buyer.holdmail_status === "Y")
    setPOApprovalLevel(Buyer.apprvllevel)
    setHeadOfficeNameHelp({
      label: Buyer.customerho_name,
      value: Buyer.customerho_id,
    })
    setcityonedefaultvalue({ label: Buyer.city, value: Buyer.cityid })
    setonestatedefaultvalue({
      label: Buyer.state,
      value: Buyer.statecode,
      id: Buyer.stateid,
    })
    setonecountrydefaultvalue({ label: Buyer.country, value: Buyer.countryid })
    setregisterType(Buyer.registertype)
    setregisterdate(moment(Buyer.issuedate, "DD/MM/YYYY").format("YYYY-MM-DD"))
    setOpeningbaltype(Buyer.openbaltype)
    setCreditflag(Buyer.credit_limit_flg === "Y")
    setIsEdit(true)
    setModal(true)
    setstatenamevalue(Buyer.state)
    setstatecodevalue(Buyer.statecode)
    setstateidvalue(Buyer.stateid)
    setstateEdit(true)
    setcityEdit(true)
    setcitynamevalue(Buyer.city)
    setcitycodevalue(Buyer.cityid)
    setcityidvalue(Buyer.cityid)
    // toggle()

    setGroupValue({
      label: Buyer.groupname,
      value: Buyer.group_id,
    })
    setsubgroup(Buyer.under_grpname)
  }

  useEffect(() => {
    getallcustomers1(Active1)
  }, [Active1])

  const resetform = () => {
    setactiveTab("1")
    setgsttrue(false)
    // setActive1(true)
    setswitch1(true)
    setuseractive(false)
    setWportal(false)
    setwalkin(false)
    setHOFlg(false)
    setzerosales(false)
    setPromotional(false)
    setIndentApporoval(false)
    // setIncludeCity(Buyer.zerosales)
    // setIncludeState(Buyer.zerosales)
    setHoldOutstanding(false)
    setPOApprovalLevel("")
    setHeadOfficeNameHelp({ label: "Select...", value: "" })
    setcityonedefaultvalue({ label: "Select...", value: "" })
    setonestatedefaultvalue(
      !isEdit ? tempState : { label: "Select...", value: "", id: "" }
    )
    setonecountrydefaultvalue(
      !isEdit ? tempCountry : { label: "Select...", value: "" }
    )
    setregisterType("Registered")
    setregisterdate(moment(new Date()).format("YYYY-MM-DD"))
    setOpeningbaltype("Dr")
    setCreditflag(false)
    setBuyerCollection({
      Customer_Name: "",
      Contact_Person: "",
      Type: "",
      Address1: "",
      Address2: "",
      Area_Code: "",
      City: "",
      Zip_Code: "",
      Phone: "",
      Fax: "",
      EmailId: "",
      AccountsMailId: "",
      PurchaseMailId: "",
      PurchaseMail_Pwd: "",
      TIN_No: "",
      Exceed_Days: "",
      bank: "",
      IssueDate: "",
      ExpiryDate: "",
      CreditLimit: "",
      Common: "",

      STNo: "",
      GSTNo: !isEdit ? tempState.value : "                ",
      PANNo: "",
      Group_Id: "",
      OpeningBal: "0.00",
      OpeningDate: "",
      AccBranch: "",
      AccNo: "",
      IFSCCode: "",
      SwiftCode: "",
      MICRCode: "",
      GPAY_NO: "",
      Distance: "",
      TaxPer: "",
      TaxType: "",
      TaxCat: "",
      CityId: "",
      Customer_Code: "",
      Cur_UserId: "",
      Cold_Call_Id: "",
      NatureOfTrans: "",
      TransPer: "",
      Credit_Limit_Flg: "",
      Customer_Id: "",

    })
    setGroupValue({
      label: 'Select...',
      value: '',
    })
    setsubgroup('')
    // if(!isEdit){
    //   setBuyerCollection({
    //     GSTNo: tempState.value
    //   })
    //   // validation.values.GSTNo = tempState.value
    //   console.log(tempState.value)
    // }
  }

  //delete user
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = Buyer => {
    //setUser(user)
    //

    setDeletiid(Buyer.customer_id)
    setDeleteModal(true)
  }

  const DeleteBuyer = async () => {
    const Deletbuy = await axios.instance
      .post(
        `/insertcustomerdetails`,
        {
          Customer_Id: Deletiid,
          Optype: "Delete",
        },
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        }
      )
      .then(res => {
        if (res.data.length == 1) {
          getallcustomers1(Active1)
          setBuyererr(true)
          setDeleteModal(false)
        } else {
          toastr.error("Already Used Cannot be Deleted", "Customer")
          setDeleteModal(false)
        }
      })
  }

  // const DeleteBuyer = async () => {
  //   const Deletbuy = await axios.instance
  //     .post(
  //       `/insertcustomerdetails`,
  //       {
  //         Customer_Id: Deletiid,
  //         Optype: "Delete",
  //       },
  //       {
  //         headers: {
  //           Authorization: tokent,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     )
  //     .then(res => {
  //     console.log(res.data)
  //       if (res.data.length != "") {
  //         if(res.data.startsWith('Error')){
  //           toastr.error("Already Used Cannot be Deleted", "Customer")
  //           setDeleteModal(false)
  //         } else {
  //           getallcustomers1(Active1)
  //           setBuyererr(true)
  //           setDeleteModal(false)
  //         }
  //       } else {
  //         toastr.error("Already Used Cannot be Deleted", "Customer")
  //         setDeleteModal(false)
  //       }
  //     })
  // }

  // const getallcustomers = async () => {
  //   const get = await axios.instance
  //     .get(
  //       `/Getallcustomersdetils/${sessionStorage.getItem("Companyid")}/${"Y"}`,
  //       {
  //         headers: {
  //           Authorization: tokent,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     )
  //     .then(res => {

  //       setallcustomercollections(res.data)
  //     })
  // }

  const getallcustomers1 = async id => {
    const get = await axios.instance
      .get(
        `/Getallcustomersdetils/${sessionStorage.getItem("Companyid")}/${id === true ? "Y" : "N"
        }`,
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        }
      )
      .then(res => {
        const data = res.data
        if (data.length > 0) {
          setallcustomercollections(res.data)

          //  dispatch(GetCUSTOMERdata())
        } else {
          setActive1(true)
          setnoRecords(true)
        }
      })
  }

  const Getallgroupid = async () => {
    const get = await axios.instance
      .get("/Getgroupid", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        setallgroupcollections1(res.data)
        const data = res.data
        console.log(data, "Getallgroups")
        const options = data.map(b => ({
          label: b.GroupName,
          value: b.Group_Id,
        }))
        setallgroupcollections(options)
      })


  }

  const selectedgroupdata1 = data1 => {
    console.log(data1)
    for (const data of data1) {
      setGroupValue({
        label: data.GroupName,
        value: data.Group_Id,
      })
      setsubgroup(data.Under_GrpName)

    }
  }
  // const Getonecity = async () => {
  //   const get = await axios.instance
  //     .get("/Getonecity", {
  //       headers: { Authorization: tokent, "Content-Type": "application/json" },
  //     })
  //     .then(res => {
  //       setonecitycollections(res.data)
  //       for (const data of res.data) {
  //         setcityonedefaultvalue({label:data.City_Name,value:data.City_Id})
  //       }
  //     })
  // }

  const Getonestates = async () => {
    const get = await axios.instance
      .get(`/Getonestate/${sessionStorage.getItem("CStateCode")}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        // setonestaecollations(res.data)
        for (const data of res.data) {
          settempState({
            label: data.StateName,
            value: data.StateCode,
            id: data.StateId,
          })

          // let statecode= data.StateCode
          // if (
          //   registerType !="Unregistered" ||registerType !="Composition"
          // ) {
          //   const formattedStateCode =  parseInt(statecode) < 10 ? `0${statecode}` : `${statecode}`;
          //   validation.values.GSTNo = formattedStateCode;
          // } else {
          //   //Dont Remove Space , it is for Empty Data 15 digit
          //   validation.values.GSTNo = "               "
          // }
        }
      })
  }

  const Getonecountry = async () => {
    const get = await axios.instance
      .get("/Getonecountry", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        for (const data of res.data) {
          settempCountry({
            label: data.CountryName,
            value: data.CountryId,
          })
        }
      })
  }

  const Getallcountrys = async () => {
    const get = await axios.instance
      .get("/Getallcountry", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.CountryName,
          value: b.CountryId,
        }))
        setallcountrycollections(options)
      })
  }

  const Getallstate = async () => {
    const get = await axios.instance
      .get("/GetallStates", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.StateName,
          value: b.StateCode,
          id: b.StateId,
        }))
        options.unshift({ label: "Add State....", value: "" })
        setallstatecollections(options)
      })
  }

  const HeadOffice = async () => {
    const get = await axios.instance
      .get(`/HeadOfficehelp/${sessionStorage.getItem("Companyid")}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.Customer_Name,
          value: b.Customer_Id,
        }))

        setHeadOfficeHelp(options)
      })
  }

  const Getallcity = async () => {
    const get = await axios.instance
      .get("/Getallcity", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.City_Name,
          value: b.City_Id,
        }))

        options.unshift({ label: "Add City....", value: "" })
        setallcitycollections(options)
      })
  }

  useEffect(() => {
    Getallcountrys()
    getallcustomers1(true)
    Getallstate()
    Getallcity()
    Getonestates()
    Getonecountry()
    HeadOffice()
    Getallgroupid()
    GetallCompany()
  }, [])

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        No
      </div>
    )
  }

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Yes
      </div>
    )
  }

  const columns = useMemo(
    () => [
      {
        Header: "Customer Name",
        filterable: true,
        accessor: "customer_name",
        disableFilters: true,
      },
      {
        Header: "Contact Person",
        filterable: true,
        accessor: "contact_person",
        disableFilters: true,
      },
      {
        Header: "Phone No",
        filterable: true,
        accessor: "phone",
        disableFilters: true,
      },
      {
        Header: "Country",
        filterable: true,
        accessor: "country",
        disableFilters: true,
      },


      {
        Header: "State",
        filterable: true,
        accessor: "state",
        disableFilters: true,
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex justify-content-center align-items-center gap-2">
              {/* edit icon */}
              <Tooltip title="Edit" placement="left-start">
                <Link
                  to="#"
                  className="text-primary"
                  onClick={() => {
                    const Buyer = cellProps.row.original
                    handleUserClick(Buyer)
                  }}
                >
                  <i
                    className="uil uil-pen font-size-18"
                    id="edittooltip"
                    style={{ color: "blue" }}
                  />
                </Link>
              </Tooltip>

              {/* delete icon */}
              <Tooltip title="Delete" placement="right-end">
                <Link
                  to="#"
                  className="text-danger"
                  onClick={() => {
                    if (JSON.parse(sessionStorage.getItem("MenuItemCustomerControls")).Del == "Y") {
                      const Buyer = cellProps.row.original
                      onClickDelete(Buyer)
                    } else {
                      toastr.warning('Please Contact Admin', 'Operation Not Allowed')
                    }
                  }}
                >
                  <i
                    className="uil uil-trash-alt font-size-18"
                    id="deletetooltip"
                  />
                </Link>
              </Tooltip>

            </div>
          )
        },
      },
    ],
    []
  )

  const GetallCompany = async () => {
    const Getcom = await axios.instance
      .get("/GetallCompany", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.Company_Name,
          value: b.Company_Id,
        }))
        setCompanyCollection1(options)
      })
  }

  const handleCheckboxChange = () => {
    setzerosales(!zerosales)
  }

  const handleCheckboxChange1 = () => {
    setPromotional(!Promotional)
  }

  const handleCheckboxChange2 = () => {
    setIndentApporoval(!IndentApporoval)
  }

  const handleCheckboxChange3 = () => {
    setIncludeCity(!IncludeCity)
  }

  const handleCheckboxChange4 = () => {
    setIncludeState(!IncludeState)
  }

  const handleCheckboxChange5 = () => {
    setHoldOutstanding(!HoldOutstanding)
  }

  const AddColumns = () => {
    const OpenningBalanceCollection = []
    OpenningBalanceCollection.push({
      BillNo: "",
      BillDate: "",
      Amount: "",
      Type: "Dr",
      Sel: "N",
    })
    setopeningbaldata([...openingbaldata, ...OpenningBalanceCollection])
    // setval({'label':'Select...','value':''})
  }

  const toggledeletemodal = index => {
    let filteredData = openingbaldata.filter((i, indx) => indx != index)
    setopeningbaldata(filteredData)
  }

  const InserrtOpeningBal = async Customerid => {
    for (const data of openingbaldata) {
      const Receiptdetails = Object.assign(data, {
        BillNo: data.BillNo,
        BillDate: data.BillDate,
        CustomerId: Customerid,
        Amount: data.Amount,
        Type: data.Type,
        Optype: "new",
        BranchId: sessionStorage.getItem("BranchID"),
      })

      const createdetail = await axios.instance
        .post(`/InsertOpeningBal`, Receiptdetails, {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        })
        .then(res => {
          // setorderidarr([])
          // setreceiptsuccess(true)
        })
    }
    // setpaymentdata([])
  }

  const GetOneOpeningBal = async customerid => {
    const get = await axios.instance
      .get(`/GetOneOpeningBal/${customerid}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data

        setopeningbaldata(data)
      })
  }

  function calculateBalance(data) {
    let drSum = 0
    let crSum = 0

    data.forEach(item => {
      if (item.Type === "Dr") {
        drSum += item.Amount
      } else if (item.Type === "Cr") {
        crSum += item.Amount
      }
    })
    validation.values.OpeningBal = Math.abs(drSum - crSum)
    toggle1()
  }

  const InserrtOpeningBaledit = async Customerid => {
    for (const data of openingbaldata) {
      const Receiptdetails = Object.assign(data, {
        BillNo: data.BillNo,
        BillDate: data.BillDate,
        CustomerId: Customerid,
        Amount: data.Amount,
        Type: data.Type,
        Optype: "edit",
        BranchId: sessionStorage.getItem("BranchID"),
      })

      const createdetail = await axios.instance
        .post(`/InsertOpeningBal`, Receiptdetails, {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        })
        .then(res => {
          // setorderidarr([])
          // setreceiptsuccess(true)
        })
    }
    // setpaymentdata([])
  }

  // const OpeningTotal= openingbaldata.reduce((accumulator, object,) => {
  // return accumulator + (object['Amount'])  }, 0)

  return (
    <React.Fragment>
      {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={DeleteBuyer}
        onCloseClick={() => setDeleteModal(false)}
      /> */}
      <div className="page-content" style={{ backgroundColor: "inherit" }}>
        <div className="">
          <Row>

            <Col xs="12">
              <h6 className="titleviewinspections">Customer Master</h6>
              <Card>
                <CardBody>
                  <div>
                    {/* <Breadcrumbs
                      title=" Master"
                      breadcrumbItem="Customer Master"
                    /> */}
                  </div>
                  <Divider sx={{ mb: 2 }} />
                  <div className="d-flex justify-content-end align-items-center mt-3">
                    <Col
                      xl={12}
                      className="d-flex justify-content-end gap-2 align-items-center"
                    >
                      <div
                        className="d-flex d-flex-column gap-2 justify-content-end align-items-center pr-2"
                        style={{
                          borderRight: "1px solid #61677A",
                          paddingRight: "10px",
                        }}
                      >
                        <h5 className="font-size-14 mt-1">Active Customers</h5>
                        <div className="mt-2">
                          <Switch
                            onChange={checked => {
                              {
                                setActive1(checked)
                              }

                              // getallcustomers1(checked)
                            }}
                            checked={Active1}
                            width={40}
                            height={20}
                          />
                        </div>
                      </div>
                      <CustomButton
                        variant="contained"
                        onClick={() => {
                          // if(JSON.parse(sessionStorage.getItem("MenuItemCustomerControls")).New == "Y"){                               
                          setIsEdit(false)
                          validation.resetForm()
                          resetform()
                          setModal(true)
                          setstatenamevalue(tempState.label)
                          setstatecodevalue(tempState.value)
                          setstateidvalue(tempState.id)
                          setstateEdit(true)
                          setcityEdit(false)
                          // toggle()                          
                          // }else{
                          //   toastr.warning('Please Contact Admin', 'Operation Not Allowed')
                          // }                            
                        }}
                        size="small"
                      >
                        Add Customer
                      </CustomButton>
                    </Col>
                  </div>

                  {/* <div className="d-flex justify-content-end">
                    <Col xl={2}>
                      <h5 className="font-size-14 mt-1">Active</h5>

                      <div className="mt-2">
                        <Switch
                          onChange={checked => {
                            {
                              checked ? setActive1(true) : setActive1(false)
                            }
                           
                            getallcustomers1(checked)
                          }}
                          checked={Active1}
                          width={40}
                          height={20}
                        />
                      </div>
                    </Col>
                    <Link
                      style={{ height: "40px" }}
                      to="#"
                      className="btn btn-success"
                      onClick={() => {
                        setUserList("")
                        setIsEdit(false)
                        toggle()
                      }}
                    >
                      + Add New
                    </Link>
                  </div> */}
                  {/* <TableContainer
                    columns={columns}
                    data={allcustomercollections}
                    isGlobalFilter={true}
                    isAddUsers={false}
                    isAddTableWithoutBorderStrap={true}
                    // handleUserClicks={handleUserClicks}
                  /> */}
                  <div>
                    {/* <Card className="">
                                          <CardBody> */}
                    <div className="Tabelinspections">
                      <TableContainer>
                        <Table className="InspectionTbls">
                          <TableHead>
                            <TableRow>
                              <TableCell>Customer Name </TableCell>
                              <TableCell align="left">Contact Person</TableCell>
                              <TableCell>Phone NO  </TableCell>
                              <TableCell>Country  </TableCell>
                              <TableCell>State  </TableCell>
                              <TableCell>Edit</TableCell>
                              <TableCell>Delete</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {allcustomercollections.length != 0 ? (
                              changepage().map((data, index) => (
                                <TableRow key={index}>
                                  <TableCell style={{ textAlign: "left" }}>
                                    {data.customer_name}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center" }}>
                                    {data.contact_person}
                                  </TableCell>

                                  <TableCell style={{ textAlign: "center" }}>
                                    {data.phone}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center" }}>
                                    {data.country}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center" }}>
                                    {data.state}
                                  </TableCell>

                                  <TableCell align="left">
                                    <IconButton size="small">
                                      {/* <VisibilityIcon fontSize="small"  */}
                                      <EditIcon
                                        fontSize="small"
                                        color="primary"
                                        onClick={() => {
                                          // editdata(data);
                                          console.log(data);
                                          // setdeleteid(data.Termsid);
                                          // setisedit(true);
                                          handleUserClick(data)
                                        }}
                                      />
                                    </IconButton>
                                  </TableCell>
                                  <TableCell align="left">
                                    <IconButton size="small">
                                      <DeleteIcon
                                        color="error"
                                        fontSize="small"
                                        onClick={() => {
                                          // setdeletedconfirm(true);
                                          // setdeleteid(data.Termsid);
                                          setdeletedconfirm(true);
                                          // toggledeletemodal(data.branch_id)
                                          // onClickDelete(data.customer_id)
                                          setDeletiid(data.customer_id)
                                        }}
                                      />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableCell align="left">NO Data Found</TableCell>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      <TablePagination
                        component="div"
                        rowsPerPageOptions={pages}
                        count={allcustomercollections.length}
                        rowsPerPage={rowsperpage}
                        page={page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                      />
                    </div>
                    {/* <Backdrop open={open}>
                                              <Spinner name="ball-spin-fade-loader" color="#fafafa" />
                                              <p style={{ marginTop: '50px' }}></p>
                                            </Backdrop> */}
                    {/* </CardBody>
                                        </Card> */}

                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={modal} toggle={toggle} size="lg" centered>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit Customer" : "Add Customer"}
            </ModalHeader>
            <ModalBody>
              <div className="page-content ">
                <Container
                  style={{
                    // marginTop: 100,
                  }}
                >
                  <Row>
                    <Col lg="12">
                      <Nav tabs>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "1",
                            })}
                            onClick={() => {
                              toggle12("1")
                            }}
                          >
                            <span className="d-block d-sm-none">
                              <i className="far fa-building"></i>
                            </span>
                            <span className="d-none d-sm-block">
                              Basic Info
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "2",
                            })}
                            onClick={() => {
                              tab1validtiontab1("2")
                            }}
                          >
                            <span className="d-block d-sm-none">
                              <i className="far fa-user"></i>
                            </span>
                            <span className="d-none d-sm-block">GST Info</span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "3",
                            })}
                            onClick={() => {
                              tab1validtiontab2("3")
                            }}
                          >
                            <span className="d-block d-sm-none">
                              <i className="fas fa-university"></i>
                            </span>
                            <span className="d-none d-sm-block">Bank Info</span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "4",
                            })}
                            onClick={() => {
                              tab1validtiontab2("4")
                            }}
                          >
                            <span className="d-block d-sm-none">
                              <i className="fas fa-university"></i>
                            </span>
                            <span className="d-none d-sm-block">
                              Opening Balance
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "5",
                            })}
                            onClick={() => {
                              tab1validtiontab2("5")
                            }}
                          >
                            <span className="d-block d-sm-none">
                              <i className="fas fa-university"></i>
                            </span>
                            <span className="d-none d-sm-block">
                              Date Range
                            </span>
                          </NavLink>
                        </NavItem>
                      </Nav>

                      <TabContent
                        activeTab={activeTab}
                        className="p-3 text-muted"
                      >
                        <TabPane tabId="1">
                          <Row>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label htmlFor="manufacturerbrand">
                                  <b>Company Name </b>
                                </Label>
                                <Select
                                  options={CompanyCollection1}
                                  classNamePrefix="select2-search-disable"
                                  // defaultValue={{'label' : 'All' , 'value' : '0'}}
                                  isDisabled={true}
                                  value={companyNameHelp}
                                  onChange={value => {
                                    setcompanyNameHelp(value)
                                  }}
                                />
                              </div>
                            </Col>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label for="basicpill-contactperson-input2">
                                  Contact Person{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Contact_Person"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-contactperson-input2"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Contact_Person || ""}
                                  invalid={
                                    validation.touched.Contact_Person &&
                                      validation.errors.Contact_Person
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.Contact_Person &&
                                  validation.errors.Contact_Person ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Contact_Person}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            {/* Comment On Yuki 27/03/2024 */}
                            {/* <Col xl={2}>
                              <h5 className="font-size-14 mt-1">Walk in</h5>
                              <div className="mt-2">
                                <Switch
                                  onChange={checked => {
                                    {
                                      setwalkin(checked)
                                    }
                                  }}
                                  checked={walkin}
                                  width={40}
                                  height={20}
                                />
                              </div>
                            </Col>
                            <Col xl={2}>
                              <h5 className="font-size-14 mt-1">WPortal</h5>
                              <div className="mt-2">
                                <Switch
                                  onChange={checked => {
                                    {
                                      setWportal(checked)
                                    }
                                  }}
                                  checked={Wportal}
                                  width={40}
                                  height={20}
                                />
                              </div>
                            </Col> */}
                          </Row>
                          <Row>
                            <Col lg="4">
                              <div className="mb-3">
                                <Label for="basicpill-firstname-input1">
                                  Customer Name{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Customer_Name"
                                  type="text"
                                  className="form-control text-capitalize"
                                  id="basicpill-firstname-input1"
                                  onChange={validation.handleChange}
                                  max={60}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Customer_Name || ""}
                                  invalid={
                                    validation.touched.Customer_Name &&
                                      validation.errors.Customer_Name
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.Customer_Name &&
                                  validation.errors.Customer_Name ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Customer_Name}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="2">
                              <div className="mb-3">
                                <Label for="basicpill-code-input1">Code</Label>
                                <Input
                                  autoComplete="off"
                                  name="Customer_Code"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-code-input1"
                                  disabled
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Customer_Code || ""}
                                  invalid={
                                    validation.touched.Customer_Code &&
                                      validation.errors.Customer_Code
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>
                            <Col lg="3">
                              <div className="mb-3">
                                <Label for="basicpill-lastname-input2">
                                  Under Group
                                </Label>
                                <span style={{ color: "red" }}>*</span>
                                <Select
                                  options={allgroupcollections}
                                  classNamePrefix="select2-search-disable"
                                  // defaultValue={{'label' : 'All' , 'value' : '0'}}
                                  value={GroupValue}
                                  onChange={value => {
                                    setsubgroup('')
                                    console.log(value)

                                    let Groupdata = allgroupcollections1.filter(item => (item.Group_Id === value.value))
                                    console.log(Groupdata)
                                    selectedgroupdata1(Groupdata)

                                  }}
                                />
                                {/* <Input
                                  type="text"
                                  disabled
                                  defaultValue={groupname}
                                /> */}
                                {errunderurp && <p style={{ color: 'red' }}> Please Select Under Group</p>}
                              </div>

                            </Col>
                            <Col lg="3">
                              <div className="mb-3">
                                <Label for="basicpill-lastname-input2">
                                  Under Group
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Contact_Person"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-undergroup-input1"
                                  value={subgroup}
                                  disabled
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col lg="6">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-address1-input3">
                                  Address 1{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  id="basicpill-address1-input3"
                                  autoComplete="off"
                                  name="Address1"
                                  type="textarea"
                                  rows="2"
                                  className="form-control"
                                  style={{ margintop: 1 }}
                                  size="sm"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Address1 || ""}
                                  invalid={
                                    validation.touched.Address1 &&
                                      validation.errors.Address1
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.Address1 &&
                                  validation.errors.Address1 ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Address1}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="6">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-address1-input3">
                                  Address 2
                                </Label>
                                <Input
                                  id="basicpill-address1-input3"
                                  autoComplete="off"
                                  name="Address2"
                                  type="textarea"
                                  rows="2"
                                  size="sm"
                                  className="form-control"
                                  style={{ margintop: 1 }}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Address2 || ""}
                                  invalid={
                                    validation.touched.Address2 &&
                                      validation.errors.Address2
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="3">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-address1-input3">
                                  Type of{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  onBlur={handleBlur}
                                  onFocus={handleFocus}
                                  onMouseOver={handleHover}
                                  onMouseLeave={handleMouseLeave}
                                  id="basicpill-address1-input3"

                                  type="select"
                                  name="Type"
                                  classNamePrefix="select2-search-disable"
                                  style={{ height: 38 }}
                                  onChange={validation.handleChange}
                                  // onBlur={validation.handleBlur}
                                  value={validation.values.Type || ""}
                                  invalid={
                                    validation.touched.Type &&
                                      validation.errors.Type
                                      ? true
                                      : false
                                  }
                                >
                                  <option value="Corporate">Corporate</option>
                                  <option value="Retailer">Retailer</option>
                                  <option value="Dealer">Dealer</option>
                                  <option value="Distributer">
                                    Distributer
                                  </option>
                                  <option value="OEM">OEM</option>
                                  <option value="End User">End User</option>
                                </Input>
                              </div>
                            </Col>
                            <Col lg="3">
                              <div className="mb-3 col-12">
                                <Label>
                                  Country{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Select
                                  name="Country"
                                  options={allcountrycollections}
                                  value={onecountrydefaultvalue} //ref={categoryref}
                                  // isDisabled
                                  classNamePrefix="select2-search-disable"
                                  onChange={value => {
                                    console.log(value, 'id')
                                    setonecountrydefaultvalue(value)
                                    setonestatedefaultvalue({
                                      label: "Select...",
                                      value: "",
                                      id: "",
                                    })
                                  }}
                                />
                                {countryErr ? (
                                  <p
                                    style={{ fontSize: "12px" }}
                                    className="error"
                                  >
                                    Please Select Country{" "}
                                  </p>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="3">
                              <div
                                style={{
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >

                                <Label for="basicpill-email-input4">
                                  State <span style={{ color: "red" }}>*</span>
                                  {/* {onecountrydefaultvalue.value == 2 ?<span style={{ color: "red" }}>*</span> :'' } */}
                                </Label>
                                {/* <div>
                                {stateEdit && (
                                  onestatedefaultvalue.value ==''?null:
                                    <IconButton
                                      aria-label="add"
                                      color="warning"
                                      size={"small"}
                                      onClick={togglestatevalue}
                                    >
                                      <EditIcon  style={{color:"orange"}}sx={{ fontSize: "15px" }} />
                                    </IconButton>
                                  )}
                                </div> */}
                              </div>
                              <div className="mb-3 col-12">
                                <Select
                                  name="CategoryId"
                                  options={allstatecollections}
                                  value={onestatedefaultvalue}
                                  classNamePrefix="select2-search-disable"
                                  onChange={value => {

                                    if (value.label == "Add State....") {
                                      // setstateedit(false)
                                      setstatenamevalue("")
                                      setstatecodevalue("")
                                      setstateidvalue("")
                                      setstateEdit(false)
                                      togglestatevalue()
                                    } else {
                                      setstatenamevalue(value.label)
                                      setstatecodevalue(value.value)
                                      setstateidvalue(value.id)
                                      setstateEdit(true)
                                      setonestatedefaultvalue(value)
                                      validation.values.GSTNo = value.value
                                      // Getonsestate(value.value)
                                    }

                                  }}
                                />
                                {stateErr ? (
                                  <p
                                    style={{ fontSize: "12px" }}
                                    className="error"
                                  >
                                    Please Select State{" "}
                                  </p>
                                ) : null}
                              </div>

                            </Col>
                            {/* <Col lg="3">
                            <div
                                style={{
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                
                              <Label for="basicpill-email-input4">
                                City1 <span style={{ color: "red" }}>*</span> 
                              </Label>
                              <div >
                                  {cityonedefaultvalue.value.length && (
                                    <IconButton
                                      aria-label="add"
                                      color="warning"
                                      size={"small"}
                                      onClick={() => {
                                        getonecityvalue(
                                          cityonedefaultvalue.value
                                        )
                                        citymodalvalue()
                                      }}
                                    >
                                      <EditIcon sx={{ fontSize: "15px" }} />
                                    </IconButton>
                                  )}
                                </div>
                                </div>

                              <div>
                                <Select
                                  name="CategoryId"
                                  options={allcitycollections}
                                  value={cityonedefaultvalue}
                                  classNamePrefix="select2-search-disable"
                                  onChange={value => {
                                    if (value.label == "Add City....") {
                                      setcitynamevalue("")
                                      setcitycodevalue("")
                                      setcityidvalue("")
                                      setcityEdit(false)
                                      citymodalvalue()

                                    } else {
                                      setcityEdit(true)
                                      setcitynamevalue(value.label)
                                      setcitycodevalue(value.value)
                                      setcityidvalue(value.id)
                                      // getonecityvalue(value.value)
                                      setcityonedefaultvalue(value)
                                    }
                                 
                                  }}
                                />
                                {cityErr ? (
                                  <p
                                    style={{ fontSize: "12px" }}
                                    className="error"
                                  >
                                    Please Select City{" "}
                                  </p>
                                ) : null}
                              </div>
                            </Col> */}
                            <Col lg="3">
                              <div
                                style={{
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <Label for="basicpill-email-input4">
                                  City <span style={{ color: "red" }}>*</span>
                                  {/* {onecountrydefaultvalue.value == 2 ?<span style={{ color: "red" }}>*</span> :'' } */}
                                </Label>
                                {/* <div>
                                  {cityonedefaultvalue.value.length ==0 &&
                                    (<IconButton
                                      aria-label="add"
                                      color="success"
                                      size={"small"}
                                      onClick={() => {  
                                        citymodalvalue()
                                      }}
                                    >
                                      <AddCircleOutlineIcon style={{color:'Green'}}
                                        sx={{ fontSize: "15px" }}
                                      />
                                    </IconButton>)
                                  }
                                  {cityEdit && (
                                    <IconButton
                                      aria-label="add"
                                      color="warning"
                                      size={"small"}
                                      onClick={() => {
                                        getonecityvalue(
                                          cityonedefaultvalue.value
                                        )
                                        citymodalvalue()
                                      }}
                                    >
                                      <EditIcon style={{color:'orange'}} sx={{ fontSize: "15px" }} />
                                    </IconButton>
                                  )}
                                </div> */}
                              </div>
                              <div>
                                <Select
                                  name="CategoryId"
                                  options={allcitycollections}
                                  //ref={categoryref}
                                  value={cityonedefaultvalue}
                                  classNamePrefix="select2-search-disable"
                                  onChange={value => {
                                    console.log(value, "city")
                                    if (value.label == "Add City....") {
                                      setcitynamevalue("")
                                      setcitycodevalue("")
                                      setcityidvalue("")
                                      setcityonedefaultvalue({
                                        label: "Select...",
                                        value: "",
                                      })
                                      setcityEdit(false)
                                      citymodalvalue()

                                    } else {
                                      setcityEdit(true)
                                      setcitynamevalue(value.label)
                                      setcitycodevalue(value.value)
                                      setcityidvalue(value.id)
                                      // getonecityvalue(value.value)
                                      setcityonedefaultvalue(value)
                                    }
                                  }}
                                />
                                {cityErr ? (
                                  <p
                                    style={{ fontSize: "12px" }}
                                    className="error"
                                  >
                                    Please Select City{" "}
                                  </p>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="3">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-phone-input1">
                                  Phone No{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  // autoComplete="off"
                                  name="Phone"
                                  type="text"
                                  className="form-control"
                                  // id="basicpill-phone-input4"
                                  // onChange={validation.handleChange}
                                  onChange={e => {
                                    // Remove non-allowed characters from the input value
                                    const sanitizedValue =
                                      e.target.value.replace(/[^0-9 ()+-]/g, "")
                                    // Update the input value with the sanitized value
                                    validation.handleChange({
                                      target: {
                                        name: "Phone",
                                        value: sanitizedValue,
                                      },
                                    })
                                  }}
                                  onKeyDown={e => {
                                    // Allow only allowed characters to be typed
                                    if (
                                      e.key !== "Tab" && // Allow Tab key
                                      !/^[0-9 ()+-]$/.test(e.key) && // Allow digits, parentheses, plus, minus
                                      e.key !== "Backspace" && // Allow Backspace key
                                      e.key !== "Delete" // Allow Delete key
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Phone || ""}
                                  invalid={
                                    validation.touched.Phone &&
                                      validation.errors.Phone
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.Phone &&
                                  validation.errors.Phone ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Phone}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="3">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-Area_Code-input1">
                                  Mobile No
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Area_Code"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-Area_Code-input1"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Area_Code || ""}
                                  invalid={
                                    validation.touched.Area_Code &&
                                      validation.errors.Area_Code
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.Area_Code &&
                                  validation.errors.Area_Code ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Area_Code}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="3">
                              <div>
                                <Label for="basicpill-pincode-input1">
                                  Pin Code{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Zip_Code"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-pincode-input4"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Zip_Code || ""}
                                  invalid={
                                    validation.touched.Zip_Code &&
                                      validation.errors.Zip_Code
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.Zip_Code &&
                                  validation.errors.Zip_Code ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Zip_Code}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="3">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-fax-input1">Fax</Label>
                                <Input
                                  autoComplete="off"
                                  name="Fax"
                                  type="number"
                                  className="form-control"
                                  id="basicpill-fax-input4"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Fax || ""}
                                  invalid={
                                    validation.touched.Fax &&
                                      validation.errors.Fax
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.Fax &&
                                  validation.errors.Fax ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Fax}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-emailid-input1">
                                  Email Id{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="EmailId"
                                  type="email"
                                  className="form-control"
                                  id="basicpill-emailid-input4"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.EmailId || ""}
                                  invalid={
                                    validation.touched.EmailId &&
                                      validation.errors.EmailId
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.EmailId &&
                                  validation.errors.EmailId ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.EmailId}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="6">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-accemailid-input1">
                                  Accounts EmailId
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="AccountsMailId"
                                  type="email"
                                  className="form-control"
                                  id="basicpill-accemailid-input4"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.AccountsMailId || ""}
                                  invalid={
                                    validation.touched.AccountsMailId &&
                                      validation.errors.AccountsMailId
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.AccountsMailId &&
                                  validation.errors.AccountsMailId ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.AccountsMailId}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-purchaseemail-input1">
                                  Purchase EmailId
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="PurchaseMailId"
                                  type="email"
                                  className="form-control"
                                  id="basicpill-purchaseemail-input4"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.PurchaseMailId || ""}
                                  invalid={
                                    validation.touched.PurchaseMailId &&
                                      validation.errors.PurchaseMailId
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.PurchaseMailId &&
                                  validation.errors.PurchaseMailId ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.PurchaseMailId}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg="6">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-purchasepass-input1">
                                  Purchase Email Password
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="PurchaseMail_Pwd"
                                  type="Password"
                                  className="form-control"
                                  id="basicpill-purchasepass-input4"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={
                                    validation.values.PurchaseMail_Pwd || ""
                                  }
                                  invalid={
                                    validation.touched.PurchaseMail_Pwd &&
                                      validation.errors.PurchaseMail_Pwd
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.PurchaseMail_Pwd &&
                                  validation.errors.PurchaseMail_Pwd ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.PurchaseMail_Pwd}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                          {/* <Row>
                              <Col lg={6} className="mb-2">
                                  <div className="mb-3 col-12"  >  
                                    <Label className="input">
                                      PO Approval level
                                    </Label>                                        
                                      <select 
                                          style={{height:"38px"}}
                                          className="input__field"
                                          value={POApprovalLevel}
                                          onChange={(e) => {
                                              // if(productcollection.length !== 0){
                                              //     setconfirmation(true)
                                              // } else {
                                                  setPOApprovalLevel(e.target.value)   
                                                                                              
                                              // }
                                          }}
                                      >
                                          {options1.map(option => (
                                              <option key={option.value} value={option.value}>
                                                  {option.text}
                                              </option>
                                          ))}
                                      </select>   
                                  </div>                                
                                </Col>
                                <Col lg="4">
                                  <div className="mb-3 col-12" >
                                    <Label>
                                      Head Office                                           
                                    </Label>
                                    <Select
                                    name="Head_Office "
                                    options={HeadOfficeHelp}
                                    //ref={categoryref}
                                    classNamePrefix="select2-search-disable"
                                    onChange={(value)=> {
                                      setHeadOfficeNameHelp({"label":value.label,"value":value.value})
                                    }}
                                    
                                    />                                 
                                  </div>                                 
                                </Col>
                                <Col xl={2}>
                                  <h5 className="font-size-14 mt-1">
                                      HO 
                                  </h5>                    
                                  <div className="mt-2">                                                                            
                                    <Switch 
                                      onChange={(checked)=>{
                                          {checked?
                                          setHOFlg(true)
                                          :
                                          setHOFlg(false)
                                          }
                                                                                 
                                      }} 
                                      checked={HOFlg} 
                                  
                                      width={40}
                                      height={20}
                                    />                                                                   
                                  </div>                                              
                                </Col> 

                             
                             
                              </Row> */}
                          <Row>
                            {/* <Col lg="2">
                                  
                                    <div className=" mb-2 d-flex justify-content-start align-item-center gap-2">
                                    <input
                                      type="checkbox"   
                                      id="manufacturerbrand"               
                                      checked={zerosales}
                                      onClick={handleCheckboxChange}                                                                           
                                    />
                                    <Label
                                      htmlFor="manufacturerbrand"
                                      style={{ marginLeft: 5, marginTop: 5 }}
                                    >
                                      Zero Sales
                                    </Label>

                                    
                                    </div>                                 
                                </Col>
                               
                              
                                <Col xl={2}>
                                <div className=" mb-2 d-flex justify-content-start align-item-center gap-2">
                                    <input
                                      type="checkbox"   
                                      id="manufacturerbrand1"               
                                      checked={Promotional}
                                      onClick={handleCheckboxChange1}                                                                           
                                    />
                                    <Label
                                      htmlFor="manufacturerbrand1"
                                      style={{ marginLeft: 5, marginTop: 5 }}
                                    >
                                      Promotional
                                    </Label>

                                    
                                    </div>                                                 
                                </Col>  */}
                            <Col lg="6" className="pe-2">
                              <div
                                style={{
                                  border: "1px solid #ccc",
                                  padding: "10px",
                                }}
                              >
                                <div className="mb-2 d-flex justify-content-start align-item-center gap-2">
                                  {/* First Checkbox */}
                                  <input
                                    type="checkbox"
                                    id="manufacturerbrand"
                                    checked={zerosales}
                                    onClick={handleCheckboxChange}
                                  />
                                  <Label
                                    htmlFor="manufacturerbrand"
                                    style={{ marginLeft: 5, marginTop: 5 }}
                                  >
                                    Zero Sales
                                  </Label>
                                  {/* </div> */}

                                  {/* <div className="mb-2 d-flex justify-content-start align-item-center gap-2"> */}
                                  {/* Second Checkbox */}
                                  <input
                                    type="checkbox"
                                    id="manufacturerbrand1"
                                    checked={Promotional}
                                    onClick={handleCheckboxChange1}
                                  />
                                  <Label
                                    htmlFor="manufacturerbrand1"
                                    style={{ marginLeft: 5, marginTop: 5 }}
                                  >
                                    Promotional
                                  </Label>
                                </div>
                                <div className=" mb-2 d-flex justify-content-start align-item-center gap-2">
                                  <input
                                    type="checkbox"
                                    id="manufacturerbrand4"
                                    checked={HoldOutstanding}
                                    onClick={handleCheckboxChange5}
                                  />
                                  <Label
                                    htmlFor="manufacturerbrand4"
                                    style={{ marginLeft: 5, marginTop: 5 }}
                                  >
                                    Hold Outstanding Auto Alert Mail
                                  </Label>
                                </div>

                                <div
                                  style={{
                                    marginTop: 10,
                                    textAlign: "center",
                                  }}
                                >
                                  Mail Integration
                                </div>
                              </div>
                            </Col>
                            <Col lg="6" className="pe-2">
                              <div
                                style={{
                                  border: "1px solid #ccc",
                                  padding: "10px",
                                }}
                              >
                                <div className="row">
                                  <div className="col-lg-12 d-flex d-flex-column justify-content-start align-item-center gap-2 ">
                                    <input
                                      type="checkbox"
                                      id="manufacturerbrand2"
                                      // checked={IncludeCity}
                                      onClick={handleCheckboxChange3}
                                      disabled
                                    />
                                    <Label
                                      htmlFor="manufacturerbrand2"
                                      style={{ marginLeft: 5, marginTop: 5 }}
                                    >
                                      Include City For Print
                                    </Label>
                                  </div>
                                  {/* </div>  
                                <div className=" mb-2 d-flex justify-content-start align-item-center gap-2"> */}
                                  <div className="col-lg-12 d-flex d-flex-row justify-content-start align-item-center gap-2">
                                    <input
                                      type="checkbox"
                                      disabled
                                      id="manufacturerbrand4"
                                      // checked={IncludeState}
                                      onClick={handleCheckboxChange4}
                                    />
                                    <Label
                                      htmlFor="manufacturerbrand4"
                                      style={{ marginLeft: 5, marginTop: 5 }}
                                    >
                                      Include State For Print
                                    </Label>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    marginTop: 10,
                                    textAlign: "center",
                                  }}
                                >
                                  Print Functionality
                                </div>
                              </div>
                            </Col>
                          </Row>

                          <Col
                            lg="12"
                            style={{
                              border: "1px solid #ccc",
                              padding: "10px",
                              marginTop: "20px",
                            }}
                          >
                            <div className="row">
                              <div className="col-lg-5">
                                <Label className="input">
                                  PO Approval level
                                </Label>
                                <div>
                                  <select
                                    style={{ height: "38px", width: "-webkit-fill-available" }}
                                    className="input__field"
                                    value={POApprovalLevel}
                                    onChange={e => {
                                      // if(productcollection.length !== 0){
                                      //     setconfirmation(true)
                                      // } else {
                                      setPOApprovalLevel(e.target.value)
                                      console.log(e.target.value)
                                      // }
                                    }}
                                  >
                                    {options1.map(option => (
                                      <option
                                        key={option.value}
                                        value={option.value}
                                      >
                                        {option.text}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              {/* <div className="mb-2 d-flex justify-content-start align-item-center gap-2"> */}
                              {/* Second Checkbox */}
                              <div className="col-lg-5">
                                <Label>Head Office</Label>
                                <Select
                                  name="Head_Office "
                                  value={HeadOfficeNameHelp}
                                  options={HeadOfficeHelp}
                                  //ref={categoryref}
                                  classNamePrefix="select2-search-disable"
                                  onChange={value => {
                                    setHeadOfficeNameHelp(value)
                                  }}
                                />
                              </div>

                              <div className="col-lg-2">
                                <h5 className="font-size-14 mt-1">HO</h5>
                                <div className="mt-2">
                                  <Switch
                                    onChange={checked => {
                                      {
                                        setHOFlg(checked)
                                        // checked
                                        //   ? setHOFlg(true)
                                        //   : setHOFlg(false)
                                      }
                                    }}
                                    checked={HOFlg}
                                    width={40}
                                    height={20}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="mb-2 d-flex justify-content-start align-item-center gap-2">
                              <input
                                type="checkbox"
                                id="manufacturerbrand3"
                                checked={IndentApporoval}
                                onClick={handleCheckboxChange2}
                              />
                              <Label
                                htmlFor="manufacturerbrand3"
                                style={{ marginLeft: 5, marginTop: 5 }}
                              >
                                Indent Approval required
                              </Label>
                            </div>

                            <div
                              style={{
                                marginTop: 10,
                                textAlign: "center",
                              }}
                            >
                              TomPG Integration
                            </div>
                          </Col>

                          <Row>
                            <Col xl={3} className="ml-2">
                              <h5 className="font-size-14 mb-1 mt-2 ml-2 pe-2">
                                Active
                              </h5>
                              {isEdit ? (
                                <div className="mt-2">
                                  {
                                    (allcustomercollections.Active = "Y" ? (
                                      <Switch
                                        uncheckedIcon={<Offsymbol />}
                                        checkedIcon={<OnSymbol />}
                                        onColor="#626ed4"
                                        onChange={() => {
                                          setswitch1(!switch1)
                                        }}
                                        checked={switch1}
                                      />
                                    ) : (
                                      <Switch
                                        uncheckedIcon={<Offsymbol />}
                                        checkedIcon={<OnSymbol />}
                                        onColor="#626ed4"
                                        onChange={() => {
                                          setswitch1(switch1)
                                        }}
                                        checked={!switch1}
                                      />
                                    ))
                                  }
                                </div>
                              ) : (
                                <div className="mt-2">
                                  <Switch
                                    uncheckedIcon={<Offsymbol />}
                                    checkedIcon={<OnSymbol />}
                                    onColor="#626ed4"
                                    onChange={() => {
                                      setswitch1(!switch1)
                                    }}
                                    checked={switch1}
                                  />
                                </div>
                              )}
                            </Col>
                            {/* <Col xl={2}>
                                <div className=" mb-2 d-flex justify-content-start align-item-center gap-2">
                                    <input
                                      type="checkbox"   
                                      id="manufacturerbrand4"               
                                      checked={HoldOutstanding}
                                      onClick={handleCheckboxChange5}                                                                           
                                    />
                                    <Label
                                      htmlFor="manufacturerbrand4"
                                      style={{ marginLeft: 5, marginTop: 5 }}
                                    >
                                      Hold Outstanding Auto Alert Mail 
                                    </Label>                                    
                                </div>                                                                                
                                </Col> */}
                          </Row>

                          <Row>
                            <div className="d-flex flex-wrap gap-3 justify-content-end mt-4">
                              <Button
                                style={{
                                  backgroundColor: "#0766AD",
                                  color: "White",
                                }}
                                color="primary"
                                className="waves-effect waves-light"
                                onClick={() => {
                                  tab1validtiontab1("2")
                                  console.log(onestatedefaultvalue, 'onestatedefaultvalue')
                                }}
                              >
                                Next
                              </Button>{" "}
                            </div>
                          </Row>
                        </TabPane>
                        <TabPane tabId="2" style={{ minHeight: "50vh" }}>
                          <Form>
                            <Row>
                              <Col lg="3">
                                <div className="mb-3">
                                  <Label for="basicpill-pancard-input5">
                                    Registration Type
                                  </Label>
                                  <Input
                                    type="select"
                                    name="RegisterType"
                                    className="form-select"
                                    style={{ height: 38, borderColor: isFocused ? 'blue' : undefined }}
                                    onFocus={() => setIsFocused(true)}
                                    onBlur={() => setIsFocused(false)}
                                    onChange={e => {
                                      // validation.handleChange('RegisterType')(e)
                                      setregisterType(e.target.value)
                                      if (e.target.value === "Unregistered") {
                                        setgsttrue(true)
                                        validation.values.GSTNo =
                                          "               "
                                      } else {
                                        setgsttrue(false)
                                        validation.values.GSTNo =
                                          onestatedefaultvalue.value
                                      }
                                    }}
                                    value={registerType}
                                  >
                                    <option value="Registered">
                                      Registered
                                    </option>
                                    <option value="Unregistered">
                                      UnRegistered
                                    </option>
                                    <option value="SEZ">SEZ</option>
                                    <option value="Composition">
                                      Composition
                                    </option>
                                  </Input>
                                </div>
                              </Col>

                              <Col lg="4">
                                <div className="mb-3">
                                  <Label for="basicpill-regdate-input6">
                                    Registration Date
                                  </Label>
                                  <Input
                                    autoComplete="off"
                                    type="date"
                                    name="MobileNo"
                                    className="form-control"
                                    min={"1000-01-01"}
                                    max={"9999-12-31"}
                                    id="basicpill-regdate-input6"
                                    value={registerdate}
                                    style={{ height: 38, borderColor: isFocused1 ? 'blue' : undefined }}
                                    onFocus={() => setIsFocused1(true)}
                                    onBlur={() => setIsFocused1(false)}
                                    onChange={e =>
                                      setregisterdate(e.target.value)
                                    }
                                  />
                                </div>
                              </Col>
                              {/* {registerType === "Unregistered" ? (
                                <Col lg="5">
                                  <div className="mb-3">
                                    <Label for="basicpill-cstno-input7">
                                      GSTIN/UIN{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </Label>
                                    <Input
                                      autoComplete="off"
                                      type="text"
                                      name="GSTNo"
                                      className="form-control"
                                      id="basicpill-cstno-input7"
                                      disabled={gsttrue}
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={" "}
                                      //  value={validation.values.GSTNo || ""}
                                      // invalid={
                                      //   validation.touched.GSTNo && validation.errors.GSTNo ? true : false
                                      // }
                                    /> */}
                              {/* {validation.touched.GSTNo && validation.errors.GSTNo ? (
                                       <FormFeedback type="invalid">{validation.errors.GSTNo}</FormFeedback>
                                     ) : null} */}
                              {/* </div>
                                </Col>
                              ) : ( */}
                              <Col lg="5">
                                <div className="mb-3">
                                  <Label for="basicpill-gstno-input7">
                                    GSTIN/UIN{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    autoComplete="off"
                                    type="text"
                                    name="GSTNo"
                                    className="form-control"
                                    id="basicpill-gstno-input7"
                                    disabled={gsttrue}
                                    // onChange={validation.handleChange}
                                    onChange={e => {
                                      const newValue = e.target.value
                                      const currentValue =
                                        validation.values.GSTNo || ""
                                      // Check if the new value doesn't overwrite the first two digits
                                      if (
                                        newValue.length >= 2 &&
                                        newValue.substring(0, 2) ===
                                        currentValue.substring(0, 2)
                                      ) {
                                        // Update the value
                                        validation.handleChange(e)
                                      }
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.GSTNo || ""}
                                    invalid={
                                      validation.touched.GSTNo &&
                                        validation.errors.GSTNo
                                        ? true
                                        : false
                                    }
                                    maxLength={15}
                                  />
                                  {validation.touched.GSTNo &&
                                    validation.errors.GSTNo ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.GSTNo}
                                    </FormFeedback>
                                  ) : null}
                                  {/* {Gsterr ? <p style={{fontSize:"12px"}} className="error">Please Enter Gst No </p> :  null} */}
                                </div>
                              </Col>
                              {/* )} */}

                              <Col lg="4">
                                <div className="mb-3">
                                  <Label for="basicpill-panno-input7">
                                    PAN No
                                  </Label>
                                  <Input
                                    autoComplete="off"
                                    type="text"
                                    name="PANNo"
                                    className="form-control"
                                    id="basicpill-panno-input7"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.PANNo || ""}
                                    invalid={
                                      validation.touched.PANNo &&
                                        validation.errors.PANNo
                                        ? true
                                        : false
                                    }
                                  />
                                </div>
                              </Col>
                              <Col lg="4">
                                <div className="mb-3">
                                  <Label for="basicpill-dlno-input6">
                                    DL No
                                  </Label>
                                  <Input
                                    autoComplete="off"
                                    name="TIN_No"
                                    type="text"
                                    className="form-control"
                                    id="basicpill-dlno-input6"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.TIN_No || ""}
                                    invalid={
                                      validation.touched.TIN_No &&
                                        validation.errors.TIN_No
                                        ? true
                                        : false
                                    }
                                  />
                                </div>
                              </Col>
                              <Col xl={4}>
                                <h5 className="font-size-14 mt-1">
                                  IGST Applicable
                                </h5>

                                <div className="mt-2">
                                  <Switch
                                    onChange={checked => {
                                      {
                                        setuseractive(checked)
                                        // checked
                                        //   ? setuseractive(true)
                                        //   : setuseractive(false)
                                      }
                                    }}
                                    checked={useractive}
                                    width={40}
                                    height={20}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row></Row>
                            <Row>
                              <div className="d-flex flex-wrap gap-3 justify-content-end mb-3">
                                <Button
                                  style={{
                                    backgroundColor: "#0766AD",
                                    color: "White",
                                  }}
                                  color="primary"
                                  className="waves-effect waves-light"
                                  onClick={() => {
                                    // if(validation.values.RegisterType === 'Unregistered'){
                                    //   if (activeTab !== tab  ) {
                                    //         setactiveTab(tab)
                                    //       }
                                    // }
                                    tab1validtiontab2("3")
                                    console.log(onestatedefaultvalue, 'onestatedefaultvalue')
                                  }}
                                >
                                  Next
                                </Button>{" "}
                              </div>
                            </Row>
                          </Form>
                        </TabPane>

                        <TabPane tabId="3" style={{ minHeight: "50vh" }}>
                          <Row>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label for="basicpill-bankname-input12">
                                  Bank Name
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="bank"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-bankname-input12"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.bank || ""}
                                  invalid={
                                    validation.touched.bank &&
                                      validation.errors.bank
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.bank &&
                                  validation.errors.bank ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.bank}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>

                            <Col lg="6">
                              <div className="mb-3">
                                <Label for="basicpill-branchname-input">
                                  Branch Name
                                </Label>
                                <Input
                                  autoComplete="off"
                                  type="text"
                                  name="AccBranch"
                                  className="form-control"
                                  id="basicpill-branchname-input"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.AccBranch || ""}
                                  invalid={
                                    validation.touched.AccBranch &&
                                      validation.errors.AccBranch
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.AccBranch &&
                                  validation.errors.AccBranch ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.AccBranch}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label for="basicpill-accno-input12">
                                  Account No
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="AccNo"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-accno-input12"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.AccNo || ""}
                                  invalid={
                                    validation.touched.AccNo &&
                                      validation.errors.AccNo
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.AccNo &&
                                  validation.errors.AccNo ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.AccNo}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>

                            <Col lg="6">
                              <div className="mb-3">
                                <Label for="basicpill-ifsc-input">
                                  IFSCCode
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="IFSCCode"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-ifsc-input"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.IFSCCode || ""}
                                  invalid={
                                    validation.touched.IFSCCode &&
                                      validation.errors.IFSCCode
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.IFSCCode &&
                                  validation.errors.IFSCCode ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.IFSCCode}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label for="basicpill-gpayno-input">
                                  GPAY NO
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="GPAY_NO"
                                  type="number"
                                  className="form-control"
                                  id="basicpill-gpayno-input"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.GPAY_NO || ""}
                                  invalid={
                                    validation.touched.GPAY_NO &&
                                      validation.errors.GPAY_NO
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.GPAY_NO &&
                                  validation.errors.GPAY_NO ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.GPAY_NO}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div className="d-flex flex-wrap gap-3 justify-content-end mb-3">
                                <Button
                                  style={{
                                    backgroundColor: "#0766AD",
                                    color: "White",
                                  }}
                                  color="primary"
                                  className="waves-effect waves-light"
                                  onClick={() => {
                                    tab1validtiontab3("4")
                                    console.log(onestatedefaultvalue, 'onestatedefaultvalue')
                                  }}
                                >
                                  Next
                                </Button>{" "}
                              </div>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="4" style={{ minHeight: "50vh" }}>
                          <Row>
                            <Col lg="10">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-openingbal-input1">
                                  Opening Balance
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="OpeningBal"
                                  type="number"
                                  className="form-control"
                                  id="basicpill-openingbal-input1"
                                  disabled={openingbaldata.length !== 0}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.OpeningBal || ""}
                                  invalid={
                                    validation.touched.OpeningBal &&
                                      validation.errors.OpeningBal
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>
                            <Col lg={2} className="mt-2 mb-2">
                              <div className="mb-3 col-12">
                                <Label className="input"></Label>
                                <select
                                  style={{ height: "38px" }}
                                  className="input__field"
                                  value={Openingbaltype}
                                  disabled={openingbaldata.length !== 0}
                                  onChange={e => {
                                    // if(productcollection.length !== 0){
                                    //     setconfirmation(true)
                                    // } else {
                                    setOpeningbaltype(e.target.value)
                                    // }
                                  }}
                                >
                                  {options2.map(option => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.text}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </Col>

                            <Col lg="4">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-creditdays-input1">
                                  Credit Days
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="Exceed_Days"
                                  type="number"
                                  className="form-control"
                                  id="basicpill-creditdays-input1"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Exceed_Days || ""}
                                  invalid={
                                    validation.touched.Exceed_Days &&
                                      validation.errors.Exceed_Days
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Col>
                            <Col lg="8">
                              <div className="mb-3 col-12">
                                <Label for="basicpill-creditlimit-input1">
                                  <div className="d-flex  d-flex-column  gap-2 justify-content-end align-items-center">
                                    Credit Limit
                                    <Switch
                                      onChange={checked => {
                                        {
                                          setCreditflag(checked)
                                        }
                                      }}
                                      checked={Creditflag}
                                      width={40}
                                      height={20}
                                    />
                                  </div>
                                </Label>
                                <Input
                                  autoComplete="off"
                                  name="CreditLimit"
                                  type="number"
                                  className="form-control"
                                  id="basicpill-creditlimit-input1"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.CreditLimit || ""}
                                  invalid={
                                    validation.touched.CreditLimit &&
                                      validation.errors.CreditLimit
                                      ? true
                                      : false
                                  }
                                // disabled={!Creditflag}
                                />
                              </div>
                            </Col>
                            {/* <Col xl={4}>
                              <div className="mt-3">
                                
                                <Switch
                                  onChange={checked => {
                                    {
                                      checked
                                        ? setCreditflag(true)
                                        : setCreditflag(false)
                                    }
                                  
                                  }}
                                  checked={Creditflag}
                                  width={40}
                                  height={20}
                                />
                              </div>
                            </Col> */}
                            <Col lg={{ size: 2, offset: 4 }}>
                              <Button
                                className="bg-info text-nowrap"
                                onClick={toggle1}
                              >
                                Add Opening Invoice Reference
                              </Button>
                            </Col>
                          </Row>
                          <Row>
                            <div className="d-flex flex-wrap gap-3 justify-content-end mt-4">
                              <Button
                                style={{
                                  backgroundColor: "#0766AD",
                                  color: "White",
                                }}
                                color="primary"
                                className="waves-effect waves-light"
                                onClick={() => {
                                  tab1validtiontab1("5")
                                  console.log(onestatedefaultvalue, 'onestatedefaultvalue')
                                }}
                              >
                                Next
                              </Button>{" "}
                            </div>
                          </Row>
                        </TabPane>
                        {/* Date Range */}
                        <TabPane tabId="5" style={{ minHeight: "50vh" }}>
                          <Box p={4}>
                            <Typography variant="h6" gutterBottom>
                              Select Day Range (1 - 31)
                            </Typography>

                            <Slider
                              value={range}
                              onChange={handleSliderChange}
                              valueLabelDisplay="auto"
                              min={1}
                              max={31}
                              sx={{ mt: 2 }}
                            />

                            <Box mt={5}>
                              <Typography variant="h6" gutterBottom>
                                Monthly Previews
                              </Typography>

                              <Grid container spacing={2}>
                                {fiscalMonthPreview.map((preview, index) => (
                                  <Grid item xs={12} sm={6} md={4} key={index}>
                                    <Paper elevation={2} sx={{ p: 2 }}>
                                      <Typography variant="subtitle1" fontWeight="bold">
                                        {preview.month}
                                      </Typography>
                                      <Typography variant="body2">
                                        Showing days: {preview.range}
                                      </Typography>
                                    </Paper>
                                  </Grid>
                                ))}
                              </Grid>
                            </Box>
                          </Box>
                          <Col>
                            {isEdit ? (
                              <div className="d-flex flex-wrap gap-3 justify-content-end mb-3 mt-5">
                                <Button
                                  style={{
                                    backgroundColor: "#0766AD",
                                    color: "White",
                                  }}
                                  // style={{color:"Blue"}}
                                  color="primary"
                                  className="waves-effect waves-light"
                                  onClick={e => {

                                    e.preventDefault()
                                    // if(JSON.parse(sessionStorage.getItem("MenuItemCustomerControls")).Edit == "Y"){                                         
                                    validation.handleSubmit()
                                    // } else{
                                    //   toastr.warning('Please Contact Admin', 'Operation Not Allowed')
                                    // }                                       
                                    return false
                                  }}
                                >
                                  Update
                                </Button>{" "}
                              </div>
                            ) : (
                              <div className="d-flex flex-wrap gap-3 justify-content-end mb-3 mt-5">
                                <Button
                                  style={{
                                    backgroundColor: "#0766AD",
                                    color: "White",
                                  }}
                                  color="primary"
                                  className="waves-effect waves-light"
                                  onClick={e => {
                                    e.preventDefault()
                                    validation.handleSubmit()
                                    return false
                                  }}
                                >
                                  Save
                                </Button>{" "}
                              </div>
                            )}
                          </Col>
                        </TabPane>

                      </TabContent>

                      <Modal
                        size="lg"
                        isOpen={modal1}
                        returnFocusAfterClose={focusAfterClose}
                      >
                        <ModalHeader
                        // toggle={() => {
                        //   toggle1()
                        //   validation.values.OpeningBal =
                        //     openingbaldata.reduce((accumulator, object) => {
                        //       return (
                        //         accumulator + parseFloat(object["Amount"])
                        //       )
                        //     }, 0)
                        // }}
                        >
                          Opening Outstanding Invoices
                        </ModalHeader>
                        <ModalBody>
                          <Card className="p-3">
                            <div style={{ marginBottom: "25px" }}>
                              <Table
                                striped
                                responsive
                                style={{ width: "100%", fontSize: "13px" }}
                              >
                                <thead>
                                  <tr className="table-info">
                                    <th className="text-center">SI No</th>
                                    <th className="text-center">Bill No</th>
                                    <th className="text-center ">Bill Date</th>
                                    <th className="text-center">Amount</th>
                                    <th className="text-center">Type</th>
                                    <th className="text-center">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <React.Fragment>
                                    {openingbaldata.map((item, index) => (
                                      <tr key={index}>
                                        <td style={{ padding: "5px" }}>
                                          {index + 1}
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <input
                                            type="text"
                                            style={{ width: "100%" }}
                                            className="inputText"
                                            value={item.BillNo}
                                            disabled={item.Sel === "R"}
                                            onChange={e => {
                                              const newInputValues = [
                                                ...openingbaldata,
                                              ]
                                              newInputValues[index].BillNo =
                                                e.target.value
                                              setopeningbaldata(newInputValues)
                                            }}
                                          />
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <input
                                            type="Date"
                                            style={{ width: "100%" }}
                                            className="inputText"
                                            min={"1000-01-01"}
                                            max={"9999-12-31"}
                                            value={item.BillDate}
                                            disabled={item.Sel === "R"}
                                            onChange={e => {
                                              const newInputValues = [
                                                ...openingbaldata,
                                              ]
                                              newInputValues[index].BillDate =
                                                e.target.value
                                              setopeningbaldata(newInputValues)
                                            }}
                                          />
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <input
                                            type="number"
                                            style={{ width: "100%" }}
                                            className="inputText"
                                            value={item.Amount}
                                            disabled={item.Sel === "R"}
                                            onChange={e => {
                                              const newInputValues = [
                                                ...openingbaldata,
                                              ]
                                              newInputValues[index].Amount =
                                                e.target.value
                                              setopeningbaldata(newInputValues)
                                            }}
                                          />
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <select
                                            className="input__field"
                                            value={item.Type}
                                            disabled={item.Sel === "R"}
                                            onChange={e => {
                                              const newInputValues = [
                                                ...openingbaldata,
                                              ]
                                              newInputValues[index].Type =
                                                e.target.value
                                              setopeningbaldata(newInputValues)
                                            }}
                                          >
                                            {options3.map(option => (
                                              <option
                                                key={option.value}
                                                value={option.value}
                                              >
                                                {option.text}
                                              </option>
                                            ))}
                                          </select>
                                        </td>
                                        <td
                                          style={{ padding: "5px" }}
                                          align="center"
                                        >
                                          {item.Sel === "R" ? (
                                            <p>Raised</p>
                                          ) : (
                                            <Link
                                              to="#"
                                              className="text-danger"
                                              onClick={() => {
                                                toggledeletemodal(index)
                                              }}
                                            >
                                              <i
                                                className="uil uil-trash-alt font-size-18"
                                                id="deletetooltip"
                                              />
                                              <UncontrolledTooltip
                                                placement="top"
                                                target="deletetooltip"
                                              >
                                                Delete
                                              </UncontrolledTooltip>
                                            </Link>
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                  </React.Fragment>
                                </tbody>
                              </Table>
                            </div>
                          </Card>
                        </ModalBody>
                        <ModalFooter>
                          {openingbaldata.length === 0 && (
                            <Button
                              color="secondary"
                              onClick={() => {
                                toggle1()
                              }}
                            >
                              Cancel
                            </Button>
                          )}
                          <Button
                            color="secondary"
                            onClick={() => {
                              AddColumns()
                            }}
                          >
                            Add one Invoice
                          </Button>
                          <Button
                            color="secondary"
                            onClick={e => {
                              if (openingbaldata.length !== 0) {
                                e.preventDefault()
                                const billdate = openingbaldata.find(
                                  item =>
                                    item.BillDate === "" || item.BillDate == 0
                                )
                                const billno = openingbaldata.find(
                                  item => item.BillNo === "" || item.BillNo == 0
                                )
                                const billamt = openingbaldata.find(
                                  item => item.Amount === "" || item.Amount == 0
                                )

                                if (billno) {
                                  setopenBillNoErr(true)
                                } else if (billdate) {
                                  setopenBillDateErr(true)
                                } else if (billamt) {
                                  setopenBillAmt(true)
                                } else {
                                  calculateBalance(openingbaldata)
                                  // validation.values.OpeningBal =
                                  // openingbaldata.reduce((accumulator, object) => {
                                  //   return (
                                  //     accumulator + parseFloat(object["Amount"])
                                  //   )
                                  // }, 0)
                                }
                              } else {
                              }
                            }}
                          >
                            Save
                          </Button>
                          {/* <Button color="secondary" onClick={() => {
                              toggle1()
                              validation.values.OpeningBal = 100
                              // values.OpeningBal=openingbaldata.reduce((accumulator, object,) => {
                              //   return accumulator + (object['Amount'])  }, 0)
                              }}>
                                Save
                            </Button> */}
                        </ModalFooter>
                      </Modal>
                    </Col>
                  </Row>
                </Container>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </div>


      <Modal isOpen={citymodal} toggle={citymodalvalue} size="md">
        <ModalHeader
          toggle={() => {
            citymodalvalue()
          }}
          tag="h4"
        >
          {cityEdit === true ? "Edit City" : "Add City"}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col lg="12">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Code</Label>
                <Input
                  autoComplete="off"
                  type="text"
                  className="form-control"
                  id="basicpill-firstname-input1"
                  name="Product_Details_Description"
                  value={citycodevalue}
                  disabled
                  onChange={e => {
                    setcitycodevalue(e.target.value)
                  }}
                />
              </div>
            </Col>
            <Col lg="12">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  City <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  autoComplete="off"
                  type="text"
                  className="form-control"
                  id="basicpill-firstname-input1"
                  name="Product_Details_Description"
                  value={citynamevalue}
                  onChange={e => {
                    // setDepartment(e.target.value)
                    setcitynamevalue(e.target.value)
                  }}
                />
                {CityNameerr == true ? (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    Please Enter City Name
                  </p>
                ) : null}
              </div>
            </Col>
            <Col xl={12}>
              <Stack
                justifyContent={"start"}
                alignItems={"center"}
                py={1}
                direction={"row"}
                spacing={2}
              >
                <h5 className="font-size-14 mb-2">Active</h5>
                <div>
                  <Switch
                    onChange={checked => {
                      {
                        checked ? setActive(true) : setActive(false)
                      }
                    }}
                    checked={Active}
                    width={40}
                    height={20}
                  />
                </div>
              </Stack>
            </Col>
          </Row>
          {/* <Row>
               
            </Row> */}
          {/* <ModalFooter> */}
          <div className="d-flex justify-content-center ">
            {cityEdit === false ? (
              <Button
                color="primary"
                style={{ backgroundColor: "#3468C0", color: "white" }}
                onClick={() => {
                  InsertCityMasterData().then(() => {
                    setActive(true)

                  })
                }}
              >
                Save
              </Button>
            ) : (
              <Button
                color="primary"
                style={{ backgroundColor: "#3468C0", color: "white" }}
                onClick={() => {
                  if (
                    JSON.parse(sessionStorage.getItem("MenuItemAccSupplierControls")).Edit ==
                    "Y"
                  ) {
                    InsertCityMasterData().then(() => {
                      setActive(true)

                    })
                  } else {
                    toastr.warning(
                      "Please Contact Admin",
                      "Operation Not Allowed"
                    )
                  }
                }}
              >
                Update
              </Button>
            )}
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={statetoggle} toggle={togglestatevalue} size="md">
        <ModalHeader
          toggle={() => {
            togglestatevalue()
          }}
          tag="h4"
        >
          {stateEdit == true ? "Edit State" : "Add State"}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col lg="12">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  {" "}
                  State Code <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  autoComplete="off"
                  type="text"
                  className="form-control"
                  id="basicpill-firstname-input1"
                  name="Product_Details_Description"
                  value={statecodevalue}
                  disabled={stateEdit}
                  onChange={e => {
                    setstatecodevalue(e.target.value)
                  }}
                />
                {statecodeerror == true ? (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    Please Enter State Code
                  </p>
                ) : null}
              </div>
            </Col>
            <Col lg="12">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  State <span style={{ color: "red" }}>*</span>
                </Label>



                <Input
                  autoComplete="off"
                  type="text"
                  className="form-control"
                  id="basicpill-firstname-input1"
                  name="Product_Details_Description"
                  value={statenamevalue}
                  onChange={e => {
                    // setDepartment(e.target.value)
                    setstatenamevalue(e.target.value)
                  }}
                />
                {statenameerror == true ? (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    Please Enter State Name
                  </p>
                ) : null}
              </div>
            </Col>
          </Row>
          {/* <Row>
               
            </Row> */}
          {/* <ModalFooter> */}
          <div className="d-flex justify-content-center ">
            {stateEdit === false ? (
              <Button
                color="primary"
                style={{ backgroundColor: "#3468C0", color: "white" }}
                onClick={() => {
                  insertstatemaster().then(() => { })
                }}
              >
                Save
              </Button>
            ) : (
              <Button
                color="primary"
                style={{ backgroundColor: "#3468C0", color: "white" }}
                onClick={() => {
                  if (
                    JSON.parse(sessionStorage.getItem("MenuItemAccSupplierControls")).Edit ==
                    "Y"
                  ) {
                    updatestatemaster().then(() => { })
                  } else {
                    toastr.warning(
                      "Please Contact Admin",
                      "Operation Not Allowed"
                    )
                  }
                }}
              >
                Update
              </Button>
            )}
          </div>
        </ModalBody>
      </Modal>


      {stateaddmessage ? (
        <SweetAlert
          title="State Added Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setstateaddmessage(false)
          }}
        ></SweetAlert>
      ) : null}
      {sateupdate ? (
        <SweetAlert
          title="State Updated Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setsateupdate(false)
          }}
        ></SweetAlert>
      ) : null}

      {Buyersuccess ? (
        <SweetAlert
          title="Customer Added Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setBuyersuccess(false)
          }}
        ></SweetAlert>
      ) : null}

      {Buyerinfo ? (
        <SweetAlert
          title="Customer Updated Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setBuyerinfo(false)
          }}
        ></SweetAlert>
      ) : null}

      {Buyererr ? (
        <SweetAlert
          title="Customer Deleted  Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setBuyererr(false)
          }}
        ></SweetAlert>
      ) : null}

      {duplicateerro ? (
        <SweetAlert
          title="Customer Already exists "
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          danger
          onConfirm={() => {
            setduplicateerro(false)
          }}
        ></SweetAlert>
      ) : null}

      {noRecords ? (
        <SweetAlert
          title="No Records Found for InActive"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setnoRecords(false)
          }}
        ></SweetAlert>
      ) : null}

      {openBillAmt ? (
        <SweetAlert
          title="Enter Bill Amount"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setopenBillAmt(false)
          }}
        ></SweetAlert>
      ) : null}

      {openBillDateErr ? (
        <SweetAlert
          title="Enter Bill Date"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setopenBillDateErr(false)
          }}
        ></SweetAlert>
      ) : null}

      {openBillNoErr ? (
        <SweetAlert
          title="Enter Bill No"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setopenBillNoErr(false)
          }}
        ></SweetAlert>
      ) : null}


      {added ? (
        <SweetAlert
          title="City Added Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setadded(false)
          }}
        ></SweetAlert>
      ) : null}

      {updated ? (
        <SweetAlert
          title="City Updated Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setupdated(false)
          }}
        ></SweetAlert>
      ) : null}

      {statealreadyExists ? (
        <SweetAlert
          title="State Already Exists"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setstatealreadyExists(false)
          }}
        ></SweetAlert>
      ) : null}

      {duplicateerr ? (
        <SweetAlert
          title="City Name Already Exist"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setduplicateerr(false)
          }}
        ></SweetAlert>
      ) : null}

      {deletedconfirm ? (
        <SweetAlert
          title="Are You Sure?"
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          confirmBtnBsStyle="success"
          showConfirm={true}
          cancelBtnBsStyle="danger"
          cancelBtnText="Cancel"
          confirmBtnText="Yes,delete it!"
          showCancel={true}
          warning
          onConfirm={() => {
            DeleteBuyer();
            setdeletedconfirm(false);
          }}
          onCancel={() => {
            setdeletedconfirm(false);
            // setdeleted(false);
          }}
        >
          <p style={{ fontSize: '20px' }}>You Won't able to revert this!</p>
        </SweetAlert>
      ) : null}

      {/* /* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </React.Fragment>
  )
}
DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default DatatableTables
